$(function () {
  hideWhatsAppWidgetOnWeekends();
  interceptAddToCartButton();
  patchCartItems();
  cartUpdate();
  if (document.getElementById('jsc-cart-fee-loader') && !document.getElementById('jsc-cart-fee-loader').hidden) {
    setCartFeeLoader(true);
  }
  removeShippingProductsAndSurcharge();
  gwpSetup();

  if (window.location.pathname.includes('/cart')) {
    scheduleCartPageCutoffRefresh();
    if (document.readyState === 'complete') {
      addCheckoutWrapper();
      toggleCheckoutButton();
      checkHospitalCodeExists();
      checkAndSetMultishippingAttribute();
    } else {
      window.addEventListener('load', function() {
        addCheckoutWrapper();
        toggleCheckoutButton();
        checkHospitalCodeExists();
        checkAndSetMultishippingAttribute();
      });
    }
  }
});

function cartUpdate() {
  $(document).on('cart.requestComplete', function(event, cart) {
    if (window.location.pathname.includes('/cart')) {
      $('.cart-count').html(cart.item_count);
      // Check if only 1 main item remains and remove multishipping if so
      checkAndRemoveMultishippingIfSingleItem();
    } else {
      window.location.reload();
    }
  });

  $(document).on('product-ajax:added', function(event) {
    window.location.reload();
  });
}

/* start: gift card msg validation */
function validateOccasionFields() {
  // Get all visible gift message templates
  const visibleTemplates = document.querySelectorAll('.jsc-gift-message-template:not(.d-none)');
  const emptyOccasions = [];
  
  visibleTemplates.forEach(template => {
    const occasionField = template.querySelector('select[name="properties[_Occasion]"]');
    if (occasionField && !occasionField.value) {
      emptyOccasions.push(occasionField);
    }
  });
  
  return emptyOccasions.length === 0;
}

function showOccasionError(form) {
  const existingError = form.querySelector('.jsc-gift-message-validation-error');
  if (existingError) {
    existingError.remove();
  }
  
  const errorMsg = document.createElement('div');
  errorMsg.className = 'jsc-gift-message-validation-error';
  errorMsg.textContent = 'The Occasion field is required. Please make a selection before adding to cart.';
  
  const giftMessageContainer = form.querySelector('.jsc-gift-messages-container');
  if (giftMessageContainer) {
    giftMessageContainer.insertAdjacentElement('afterend', errorMsg);
  } else {
    const submitButton = form.querySelector('button[name="add"], .product-form__submit');
    if (submitButton) {
      submitButton.insertAdjacentElement('beforebegin', errorMsg);
    }
  }
  
  setTimeout(function() {
    if (errorMsg && errorMsg.parentNode) {
      errorMsg.style.transition = 'opacity 0.3s';
      errorMsg.style.opacity = '0';
      setTimeout(function() {
        errorMsg.remove();
      }, 300);
    }
  }, 5000);
}
/* end: gift card msg validation */

function interceptAddToCartButton() {
  // To intercept the ATC button for multiple gift messages and addons.
  $(document).ready(function() {
    // Use event delegation for button clicks to handle dynamically added buttons
    document.addEventListener('click', function(e) {
      // Check if clicked element or its ancestor is an add to cart button
      let button = e.target.closest('button[name="add"]');
      if (!button) {
        button = e.target.closest('.product-form__submit');
      }
      if (!button) return;
      
      // Validate occasion fields before proceeding
      if (!validateOccasionFields()) {
        e.preventDefault();
        e.stopPropagation();
        const productForm = button.closest('form');
        if (productForm) {
          showOccasionError(productForm);
        }
        return false;
      }
      
      const additionalGiftCardCheckbox = document.getElementById('additional-gift-card');
      const selectedAddons = getSelectedAddons();
      
      if (additionalGiftCardCheckbox && additionalGiftCardCheckbox.checked) {
        e.preventDefault();
        handleMultipleGiftMessageSubmission(button, selectedAddons);
      } else if (selectedAddons.length > 0) {
        e.preventDefault();
        handleAddonSubmission(button, selectedAddons);
      }
    }, true);
    
    // Also intercept form submit events
    document.addEventListener('submit', function(e) {
      const form = e.target.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;
      
      // Validate occasion fields before proceeding
      if (!validateOccasionFields()) {
        e.preventDefault();
        e.stopPropagation();
        showOccasionError(form);
        return false;
      }
    }, true);
  });
}

function handleMultipleGiftMessageSubmission(originalButton, selectedAddons = []) {
  const quantityInput = document.querySelector('input[name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  
  if (quantity <= 1) {
    originalButton.click();
    return;
  }
  
  const productForm = originalButton.closest('form');
  if (!productForm) {
    console.error('Product form not found');
    return;
  }
  
  const variantIdInput = productForm.querySelector('input[name="id"]');
  if (!variantIdInput) {
    console.error('Product variant ID not found');
    return;
  }
  
  const variantId = variantIdInput.value;
  
  originalButton.disabled = true;
  originalButton.classList.add('btn--loading');
  
  const giftMessageSets = collectGiftMessageSets(quantity);
  
  submitMultipleGiftMessages(variantId, giftMessageSets, originalButton, selectedAddons);
}

function handleAddonSubmission(originalButton, selectedAddons) {
  const quantityInput = document.querySelector('input[name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  
  const productForm = originalButton.closest('form');
  if (!productForm) {
    console.error('Product form not found');
    return;
  }
  
  const variantIdInput = productForm.querySelector('input[name="id"]');
  if (!variantIdInput) {
    console.error('Product variant ID not found');
    return;
  }
  
  const variantId = variantIdInput.value;
  
  originalButton.disabled = true;
  originalButton.classList.add('btn--loading');
  
  submitMainProductWithAddons(variantId, quantity, selectedAddons, originalButton);
}

function generateRandomString() {
  // Act as a binding ID for the main product and addons.
  const datetime = Date.now();
  const randomString = Math.random().toString(36).substring(2, 15);
  return `${datetime}-${randomString}`;
}

function getSelectedAddons() {
  const selectedAddons = [];
  const addonButtons = document.querySelectorAll('.jsc-addon-select-btn.selected');
  
  addonButtons.forEach(button => {
    selectedAddons.push({
      productId: button.dataset.addonProductId,
      variantId: button.dataset.addonVariantId,
      price: button.dataset.addonPrice
    });
  });

  return selectedAddons;
}

function collectGiftMessageSets(quantity) {
  const giftMessageSets = [];
  const setsContainer = document.querySelector('.jsc-gift-message-sets');
  
  for (let i = 1; i <= quantity; i++) {
    const messageSet = setsContainer.querySelector(`.jsc-gift-message-template:not(.d-none) [data-message-index="${i}"]`);
    if (messageSet) {
      const giftData = {
        initial: messageSet.querySelector('input[name="properties[Initial]"]')?.value || '',
        nameForPersonalization: messageSet.querySelector('input[name="properties[Name For Personalisation]"]')?.value || '',
        recipientName: messageSet.querySelector('[name="properties[Recipient Name]"]')?.value || '',
        giftMessage: messageSet.querySelector('textarea[name="properties[Gift Message]"]')?.value || '',
        senderName: messageSet.querySelector('[name="properties[Sender Name]"]')?.value || '',
        occasion: messageSet.querySelector('select[name="properties[_Occasion]"]')?.value || ''
      };
      giftMessageSets.push(giftData);
    }
  }

  return giftMessageSets;
}

function submitMultipleGiftMessages(variantId, giftMessageSets, originalButton, selectedAddons = []) {
  const items = [];

  giftMessageSets.forEach((giftData, index) => {
    const hasAddons = selectedAddons.length > 0;
    const bindingId = hasAddons ? generateRandomString() : null;
    
    const itemProperties = {
      'Recipient Name': giftData.recipientName,
      'Gift Message': giftData.giftMessage,
      'Sender Name': giftData.senderName,
      '_Occasion': giftData.occasion
    };
    
    // Add Initial property if present
    if (giftData.initial) {
      itemProperties['Initial'] = giftData.initial;
    }

    if (giftData.nameForPersonalization) {
      itemProperties['Name For Personalisation'] = giftData.nameForPersonalization;
    }
    
    if (hasAddons) {
      itemProperties['_Binding_ID'] = bindingId;
    }
    
    // Add main product for this gift message
    items.push({
      id: variantId,
      quantity: 1,
      properties: itemProperties
    });
    
    // Add addons as children with parent_id reference
    if (hasAddons) {
      selectedAddons.forEach(addon => {
        items.push({
          id: addon.variantId,
          quantity: 1,
          parent_id: variantId,
          properties: {
            '_Is_Addon': 'true',
            '_Binding_ID': bindingId
          }
        });
      });
    }
  });
  
  // Use native Shopify API to add all items at once
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then((res) => res.json())
    .then((cart) => {
      originalButton.disabled = false;
      originalButton.classList.remove('btn--loading');
      // Reload page after successful add, just like normal ATC
      window.location.reload();
    })
    .catch((error) => {
      console.error('Error adding items to cart:', error);
      originalButton.disabled = false;
      originalButton.classList.remove('btn--loading');
    });
}

function submitMainProductWithAddons(variantId, quantity, selectedAddons, originalButton) {
  // Prepare cart items array
  const items = [];
  
  const hasAddons = selectedAddons.length > 0;
  const bindingId = hasAddons ? generateRandomString() : null;
  
  // Collect gift message properties from the first/default gift message set
  const mainProductProperties = {};
  const setsContainer = document.querySelector('.jsc-gift-message-sets');
  
  if (setsContainer) {
    const firstMessageSet = setsContainer.querySelector('.jsc-gift-message-template:not(.d-none) [data-message-index="1"]') || 
                            setsContainer.querySelector('[data-message-index="1"]');
    
    if (firstMessageSet) {
      const initial = firstMessageSet.querySelector('input[name="properties[Initial]"]')?.value || '';
      const nameForPersonalization = firstMessageSet.querySelector('input[name="properties[Name For Personalisation]"]')?.value || '';
      const recipientName = firstMessageSet.querySelector('[name="properties[Recipient Name]"]')?.value || '';
      const giftMessage = firstMessageSet.querySelector('textarea[name="properties[Gift Message]"]')?.value || '';
      const senderName = firstMessageSet.querySelector('[name="properties[Sender Name]"]')?.value || '';
      const occasion = firstMessageSet.querySelector('select[name="properties[_Occasion]"]')?.value || '';
      
      if (initial) {
        mainProductProperties['Initial'] = initial;
      }
      if (nameForPersonalization) {
        mainProductProperties['Name For Personalisation'] = nameForPersonalization;
      }
      if (recipientName) {
        mainProductProperties['Recipient Name'] = recipientName;
      }
      if (giftMessage) {
        mainProductProperties['Gift Message'] = giftMessage;
      }
      if (senderName) {
        mainProductProperties['Sender Name'] = senderName;
      }
      if (occasion) {
        mainProductProperties['_Occasion'] = occasion;
      }
    }
  }
  
  if (hasAddons) {
    mainProductProperties['_Binding_ID'] = bindingId;
  }
  
  // Add main product
  items.push({
    id: variantId,
    quantity: quantity,
    properties: mainProductProperties
  });
  
  // Add selected addons as children with parent_id reference
  if (hasAddons) {
    selectedAddons.forEach(addon => {
      items.push({
        id: addon.variantId,
        quantity: quantity,
        parent_id: variantId,
        properties: {
          '_Is_Addon': 'true',
          '_Binding_ID': bindingId
        }
      });
    });
  }
  
  // Use native Shopify API to add all items at once
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then((res) => res.json())
    .then((cart) => {
      originalButton.disabled = false;
      originalButton.classList.remove('btn--loading');
      // Reload page after successful add, just like normal ATC
      window.location.reload();
    })
    .catch((error) => {
      console.error('Error adding items to cart:', error);
      originalButton.disabled = false;
      originalButton.classList.remove('btn--loading');
    });
}

function patchCartItems() {
  // To sync the quantity of the main product and addons.
  customElements.whenDefined('cart-items').then(() => {
    const CartItemsClass = customElements.get('cart-items');
    
    if (!CartItemsClass || CartItemsClass.prototype.isPatchedByJSC) {
      return;
    }

    const originalShowLoader = CartItemsClass.prototype.showLoader;
    const originalHideLoader = CartItemsClass.prototype.hideLoader;
    const originalUpdateQuantity = CartItemsClass.prototype.updateQuantity;
    
    // Function to find and remove orphaned addon items (addons whose parent main item doesn't exist)
    async function removeOrphanedAddons() {
      try {
        // Fetch current cart data from API
        const cartResponse = await fetch(`${FoxTheme.routes.cart_url}.js`, { ...FoxTheme.utils.fetchConfig() });
        if (!cartResponse.ok) {
          throw new Error('Failed to fetch cart');
        }
        const cartData = await cartResponse.json();
        
        if (!cartData.items || cartData.items.length === 0) {
          return; // No items in cart
        }
        
        // Separate main items and addon items
        const mainItems = [];
        const addonItems = [];
        
        cartData.items.forEach(item => {
          const isAddon = item.properties && item.properties['_Is_Addon'] === 'true';
          if (isAddon) {
            addonItems.push(item);
          } else {
            mainItems.push(item);
          }
        });
        
        // Find orphaned addons (addons whose parent main item doesn't exist)
        const orphanedAddons = [];
        
        addonItems.forEach(addonItem => {
          // Nested shipping and surcharges are removed by line number. update.js
          // keys are not unique across nested lines of the same variant.
          const shippingHandle = getCartFeeProducts().shippingHandle;
          const shippingVariantId = getMultishipShippingVariantId();
          if (
            addonItem.parent_relationship
            || (shippingVariantId && Number(addonItem.variant_id) === shippingVariantId)
            || (shippingHandle && addonItem.handle === shippingHandle)
          ) {
            return;
          }

          const addonBindingId = addonItem.properties && addonItem.properties['_Binding_ID'];
          
          // Remove addons without binding ID
          if (!addonBindingId || addonBindingId.trim() === '') {
            orphanedAddons.push({
              key: addonItem.key
            });
            return;
          }
          
          // Check if parent main item exists (main item with same binding ID)
          const parentMainItem = mainItems.find(mainItem => {
            const mainBindingId = mainItem.properties && mainItem.properties['_Binding_ID'];
            return mainBindingId === addonBindingId;
          });
          
          if (!parentMainItem) {
            // Parent not found - this is an orphaned addon
            orphanedAddons.push({
              key: addonItem.key
            });
          }
        });
        
        // Remove orphaned addons if any found
        if (orphanedAddons.length > 0) {
          const updates = {};
          orphanedAddons.forEach(orphan => {
            updates[orphan.key] = 0; // Set quantity to 0 to remove
          });
          
          if (Object.keys(updates).length > 0) {
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
            );
            
            const body = JSON.stringify({
              updates: updates,
              sections: sectionsToBundle,
            });
            
            fetch(`${FoxTheme.routes.cart_url}/update.json`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
              .then((response) => response.json())
              .then((parsedState) => {
                console.log(`Removed ${orphanedAddons.length} orphaned addon item(s)`);
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
              })
              .catch((error) => {
                console.error('JSC Orphaned Addon Removal Error:', error);
              });
          }
        }
      } catch (error) {
        console.error('JSC Orphaned Addon Check Error:', error);
      }
    }
    
    CartItemsClass.prototype.updateQuantity = function(line, quantity, name, target) {
      const mainItemRow =
        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      
      if (!mainItemRow) {
        console.error(`Failed cart patching: Could not find main item row for line: ${line}`);
        // Still try to proceed with original behavior if main item not found
        return originalUpdateQuantity.call(this, line, quantity, name, target);
      }

      // Check if this is an addon item - if so, don't process addons (addons don't have addons)
      const isAddonItem = mainItemRow.classList.contains('jsc-cart-item-addon');
      if (isAddonItem) {
        // For addon items, use original behavior (no special handling needed)
        return originalUpdateQuantity.call(this, line, quantity, name, target);
      }

      const mainItemKey = mainItemRow.dataset.key;
      const mainBindingId = mainItemRow.dataset.bindingId;

      if (!mainItemKey) {
        console.error(`Failed cart patching: Missing data-key on row ${line}. Did you update main-cart.liquid?`);
        return originalUpdateQuantity.call(this, line, quantity, name, target);
      }
      
      originalShowLoader.call(this, line);
      const updates = {};
      updates[mainItemKey] = quantity;

      // Process addons if main item has a binding ID (non-empty string).
      // GWP addons stay at qty 1 and are managed by gwpSetup — do not sync them.
      if (mainBindingId && mainBindingId.trim() !== '') {
        const addonItems = document.querySelectorAll(`.jsc-cart-item-addon[data-binding-id="${mainBindingId}"]`);
        
        if (addonItems.length > 0) {
          addonItems.forEach(addonItem => {
            const addonItemKey = addonItem.dataset.key;
            const addonItemIndex =
              addonItem.dataset.index ||
              addonItem.id.replace('CartItem-', '').replace('CartDrawer-Item-', '');

            // GWP stays at qty 1 while parent exists; remove it when parent is removed.
            if (addonItem.dataset.isGwp === 'true') {
              if (quantity === 0 && addonItemKey) {
                updates[addonItemKey] = 0;
                originalShowLoader.call(this, addonItemIndex);
              }
              return;
            }

            if (addonItemKey) {
              updates[addonItemKey] = quantity;
              originalShowLoader.call(this, addonItemIndex);
            } else {
              console.error(`Failed cart patching: Missing data-key on addon item row ${addonItemIndex}.`);
            }
          });
        }
      }
      
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const body = JSON.stringify({
        updates: updates,
        sections: sectionsToBundle,
      });

      fetch(`${FoxTheme.routes.cart_url}/update.json`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((parsedState) => {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState, target, line, name });
          // Check if only 1 main item remains and remove multishipping if so
          checkAndRemoveMultishippingIfSingleItem();
        })
        .catch((error) => {
          console.error('JSC Cart Update Error:', error);
          Object.keys(updates).forEach((key, index) => {
             originalHideLoader.call(this, line);
          });
        });
    };

    CartItemsClass.prototype.isPatchedByJSC = true;
    
    // Run on page load to clean up any existing orphaned addons
    // (Main item updates/removals already handle bound addons through updateQuantity)
    // Works on both cart page and when cart drawer is available
    const isCartPage = window.location.pathname.includes('/cart');
    const hasCartDrawer = document.querySelector('cart-drawer') !== null;
    
    if (isCartPage || hasCartDrawer) {
      setTimeout(removeOrphanedAddons, 500);
    }
  });
}

//start: align button to the tallest height
function equalizeTitlesHeight(selectors) {
  selectors.forEach(selector => {
    const titles = document.querySelectorAll(selector);
    if (!titles.length) return;

    let maxHeight = 0;

    titles.forEach(t => {
      t.style.height = 'auto';
      const h = t.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });
    titles.forEach(t => t.style.height = maxHeight + 'px');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  equalizeTitlesHeight([
    '.article-card__title', 
    '[class*="__multicolumn_icon_nRHHNE"] .multicolumn-card__title',
    '[class*="__multicolumn_cEnejW"] .multicolumn-card__text'
  ]);
});

window.addEventListener('resize', () => {
  clearTimeout(window.titleResizeTimer);
  window.titleResizeTimer = setTimeout(() => {
    equalizeTitlesHeight([
      '.article-card__title', 
      '[class*="__multicolumn_icon_nRHHNE"] .multicolumn-card__title',
      '[class*="__multicolumn_cEnejW"] .multicolumn-card__text'
    ]);
  }, 200);
});


// checking if the card has title + text
function getOuterHeight(el) {
  if (!el) return 0;
  const style = window.getComputedStyle(el);
  const marginTop = parseFloat(style.marginTop) || 0;
  const marginBottom = parseFloat(style.marginBottom) || 0;
  return el.offsetHeight + marginTop + marginBottom;
}

function equalizeSectionCards(selector) {
  const cards = document.querySelectorAll(selector);
  if (!cards.length) return;

  let maxHeight = 0;

  cards.forEach(card => {
    const title = card.querySelector('.multicolumn-card__title');
    if (title) title.style.height = 'auto';
  });

  cards.forEach(card => {
    const title = card.querySelector('.multicolumn-card__title');
    const text = card.querySelector('.multicolumn-card__text');

    if (!title && !text) return;

    let combinedHeight = 0;
    if (title) combinedHeight += getOuterHeight(title);
    if (text) combinedHeight += getOuterHeight(text);

    if (combinedHeight > maxHeight) maxHeight = combinedHeight;
  });

  cards.forEach(card => {
    const title = card.querySelector('.multicolumn-card__title');
    const text = card.querySelector('.multicolumn-card__text');

    if (!title) return;

    if (text) {
      const titleHeight = maxHeight - getOuterHeight(text);
      title.style.height = titleHeight > 0 ? titleHeight + 'px' : 'auto';
    } else {
      title.style.height = maxHeight + 'px';
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  equalizeSectionCards('[class*="__multicolumn_jtdVVQ"] .multicolumn-card');
});

window.addEventListener('resize', () => {
  clearTimeout(window.titleResizeTimer);
  window.titleResizeTimer = setTimeout(() => {
    equalizeSectionCards('[class*="__multicolumn_jtdVVQ"] .multicolumn-card');
  }, 200);
});
//end: align button to the tallest height

//start: international products > disable checkout
toggleCheckoutButton = () => {
  var $checkoutBtn = $('button[name="checkout"]');
  var disableCheckout = false;

  // --- Check if cart items have mixed intl statuses ---
  var intlStatuses = [];
  $('.cart-item').each(function() {
    var status = $(this).data('intl-status');
    if (status) intlStatuses.push(status.trim());
  });
  var uniqueStatuses = [...new Set(intlStatuses)];

  if (uniqueStatuses.length > 1) {
    // More than one type of intl status = mismatch
    disableCheckout = true;
  }

  // --- Check checkbox state ---
  if ($('#termsCheckbox').length > 0) {
    if (!$('#termsCheckbox').is(':checked')) {
      disableCheckout = true;
    }
  }
  console.log('disable checkout from js script',disableCheckout);
  if (disableCheckout) {
    $('.checkout-overlay').fadeIn(200);
  } else {
    $('.checkout-overlay').fadeOut(200);
  }

  // --- Re-run when checkbox changes ---
  $('#termsCheckbox').off('change.toggleCheckout').on('change.toggleCheckout', toggleCheckoutButton);

}

addCheckoutWrapper = () => {
  var $checkoutBtn = $('button[name="checkout"]');
  var $additionalButtons = $('.additional-checkout-buttons');
  var $checkoutWrapper = $('.jsc-checkout-wrapper');
  //console.log('wrapper exists',$checkoutWrapper.length);

  if ($checkoutWrapper.length == 0) {
    if ($checkoutBtn.length && $additionalButtons.length) {
      $checkoutBtn.add($additionalButtons).wrapAll('<div class="jsc-checkout-wrapper"></div>');
    } else {
      $checkoutBtn.wrapAll('<div class="jsc-checkout-wrapper"></div>');
    }
    $('.jsc-checkout-wrapper').append('<div class="checkout-overlay" style="display:none;"></div>'); // 
  }
  
  toggleCheckoutButton();
}

//start: Cremation time input visibility for Mandai (postal 779393)
toggleCremationTimeInput = () => {
  const wrapper = document.querySelector('.jsc-cremation-time-wrapper');
  if (!wrapper) return;

  const zapietInput = document.querySelector('#deliveryGeoSearchField');
  const postalCode = zapietInput ? (zapietInput.value || '').trim() : '';

  const cartContainer = document.querySelector('.cart');
  const isMultishipping = cartContainer && cartContainer.getAttribute('data-multishipping-checked') === 'true';

  if (postalCode === '779393' && !isMultishipping) {
    wrapper.style.display = '';
  } else {
    wrapper.style.display = 'none';
    // Clear input when hidden
    const input = wrapper.querySelector('.jsc-cremation-time-input');
    if (input) input.value = '';
  }
}

// Poll for Zapiet input and attach listeners once available
let cremationListenerAttached = false;
setInterval(function() {
  const zapietInput = document.querySelector('#deliveryGeoSearchField');
  if (zapietInput && !cremationListenerAttached) {
    cremationListenerAttached = true;
    zapietInput.addEventListener('input', toggleCremationTimeInput);
    zapietInput.addEventListener('change', toggleCremationTimeInput);
    const observer = new MutationObserver(toggleCremationTimeInput);
    observer.observe(zapietInput, { attributes: true, attributeFilter: ['value'] });
  }
  toggleCremationTimeInput();
}, 1000);

// Also listen for multishipping checkbox changes
$(document).on('change', '.jsc-cart-multishipping-checkbox', function() {
  setTimeout(toggleCremationTimeInput, 300);
});
//end: Cremation time input visibility for Mandai (postal 779393)

$(document).on('click', '.btn-remove', function() {
  setTimeout(addCheckoutWrapper, 1500);
  // console.log('remove button clicked');
});
$(document).on('change', '.quantity__input', function() {
  setTimeout(addCheckoutWrapper, 1500);
  // console.log('qty button updated');
});
$(document).on('click', '.checkout-overlay', function() {
  // console.log('checkout overlay clicked');
  var disableCheckout = false;

  // --- Check if cart items have mixed intl statuses ---
  var intlStatuses = [];
  $('.cart-item').each(function() {
    var status = $(this).data('intl-status');
    if (status) intlStatuses.push(status.trim());
  });
  var uniqueStatuses = [...new Set(intlStatuses)];

  if (uniqueStatuses.length > 1) {
    disableCheckout = true;
  }

  if (disableCheckout) {
    $('#cartCountryPopup').fadeIn(200);
    $('.cart-popup-overlay').addClass('active');
    $('.cart-popup-content').addClass('active');
  }
  setTimeout(addCheckoutWrapper, 1500);
});
//end: international products > disable checkout

//start: pdp description more than 4 lines show more
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.description-wrapper');
  if (!wrapper) return;

  const content = wrapper.querySelector('.description-content');
  const toggle = wrapper.querySelector('.description-toggle');
  if (!content || !toggle) return;

    content.classList.add('expanded');
    const fullHeight = content.scrollHeight;
    content.classList.remove('expanded');

    const clampHeight = content.getBoundingClientRect().height;

    if (fullHeight > clampHeight + 2) {
      toggle.style.display = 'inline-block';
    } else {
      toggle.style.display = 'none';
      return;
    }

    toggle.addEventListener('click', () => {
      const isExpanded = content.classList.toggle('expanded');
      toggle.textContent = isExpanded ? 'show less' : 'show more';
    });
  });
//end: pdp description more than 4 lines show more

//start: Zapiet calendar date picker - update stretch date notice
function addWorkingDays(date, days) {
  const result = new Date(date);
  while (days > 0) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay(); // 0 = Sun, 6 = Sat
    if (day !== 0 && day !== 6) {
      days--;
    }
  }
  return result;
}

document.addEventListener('click', function(e) {
  let targetElement = e.target;
  if (targetElement.nodeType === Node.TEXT_NODE) {
    targetElement = targetElement.parentElement;
  }
  
  const dateButton = targetElement && targetElement.closest ? targetElement.closest('.Zapiet-Calendar__Date.picker__day, .Zapiet-Calendar__Date--selected.picker__day') : null;
  
  if (!dateButton) return;
  
  const noticeElement = document.querySelector('#jsc-stretch-date-notice');
  if (!noticeElement) return;
  
  const ariaLabel = dateButton.getAttribute('aria-label');
  if (!ariaLabel) return;
  
  const dateMatch = ariaLabel.match(/(\d{1,2})\s+(\w+),\s+(\d{4})/);
  if (!dateMatch) return;
  
  const day = parseInt(dateMatch[1], 10);
  const monthName = dateMatch[2];
  const year = parseInt(dateMatch[3], 10);
  const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  const monthIndex = monthNames.indexOf(monthName.toLowerCase());
  
  if (monthIndex === -1) return;
  const selectedDate = new Date(year, monthIndex, day);

  const endDate = addWorkingDays(selectedDate, 5);

  const formatDate = (date) => {
    const day = date.getDate();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const startDateFormatted = formatDate(selectedDate);
  const endDateFormatted = formatDate(endDate);

  noticeElement.innerHTML = `The date you choose begins a 5 working-day delivery window. Delivery is not guaranteed on the selected date, but will occur between <strong>${startDateFormatted} and ${endDateFormatted}</strong>.`;
}, true);

function attachDateButtonListeners() {
  const dateButtons = document.querySelectorAll('.Zapiet-Calendar__Date.picker__day, .Zapiet-Calendar__Date--selected.picker__day');
  dateButtons.forEach(button => {
    if (!button.dataset.jscListenerAttached) {
      button.dataset.jscListenerAttached = 'true';
      button.addEventListener('click', function(e) {
        setTimeout(() => updateStretchDateNotice(this), 0);
      }, true);
    }
  });
}

function updateStretchDateNotice(dateButton) {
  const noticeElement = document.querySelector('#jsc-stretch-date-notice');
  if (!noticeElement) return;
  
  const ariaLabel = dateButton.getAttribute('aria-label');
  if (!ariaLabel) return;
  
  const dateMatch = ariaLabel.match(/(\d{1,2})\s+(\w+),\s+(\d{4})/);
  if (!dateMatch) return;
  
  const day = parseInt(dateMatch[1], 10);
  const monthName = dateMatch[2];
  const year = parseInt(dateMatch[3], 10);
  const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  const monthIndex = monthNames.indexOf(monthName.toLowerCase());
  
  if (monthIndex === -1) return;
  
  const selectedDate = new Date(year, monthIndex, day);

  const endDate = addWorkingDays(selectedDate, 5);
  
  const formatDate = (date) => {
    const day = date.getDate();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  
  const startDateFormatted = formatDate(selectedDate);
  const endDateFormatted = formatDate(endDate);
  
  noticeElement.innerHTML = `The date you choose begins a 5 working-day delivery window. Delivery is not guaranteed on the selected date, but will occur between <strong>${startDateFormatted} and ${endDateFormatted}</strong>.`;
}

const observer = new MutationObserver(function(mutations) {
  attachDateButtonListeners();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    attachDateButtonListeners();
    observer.observe(document.body, { childList: true, subtree: true });
  });
} else {
  attachDateButtonListeners();
  observer.observe(document.body, { childList: true, subtree: true });
}
//end: Zapiet calendar date picker - update stretch date notice

// start: Gift Message - Templates & Modal
giftMessagesData = {
  "AN": [
    "Every day with you is a blessing, and\nI look forward to many more years\nby your side.",
    "To the love of my life,\nHappy Anniversary! Thank you for filling\nmy days with happiness, warmth, and\nlove.",
    "You bring me endless joy and I can't\nimagine a single day without you.\nWishing us a million more anniversaries\ntogether. I love you!",
    "Cheers to another year of love,\nlaughter, and happiness together.\nHappy Anniversary!",
    "Happy Anniversary to the love of\nmy life! I'm so grateful to share this\njourney with you. Here's to forever\ntogether.",
    "Happy Anniversary! You fill my life\nwith love, joy, and laughter, and I\ncan't wait to create more memories\nwith you.",
    "Wishing you both endless love and joy\nas you celebrate another year together.\nHappy Anniversary to a truly\nwonderful couple!",
    "Happy Anniversary! Congratulations\non this milestone. Wishing you continued\ngrowth, lasting success, and prosperity\nin all the years to come.",
    "Congratulations on your anniversary!\nMay your business continue to thrive and\nachieve even greater success\nin the years to come.",
    "Happy Anniversary! Every milestone\nis a reminder of your hard work,\npassion, and vision. We're excited to\nsee you keep growing!",
    "Happy Anniversary! Congratulations\non another year of success and growth.",
    "On this special anniversary, thank you\nfor your continued support and\npartnership. We look forward to another\nyear of shared success and growth"
  ],
  "BD": [
    "Happy Boss's Day!",
    "Happy Boss's Day! Thank you for setting\nhigh standards and guiding us toward\nexcellence in everything we do.",
    "Happy Boss's Day! I truly appreciate\nyour patience, guidance,\nand encouragement.",
    "Happy Boss's Day to a mentor and leader\nwho knows how to keep us inspired!"
  ],
  "BH": [
    "Happy Birthday! Wishing you success,\nhappiness, and a fantastic year ahead.",
    "May your birthday be filled with joy,\nlaughter, and all the little things\nthat make you smile.",
    "Happy Birthday, my love! Every moment\nwith you is a blessing, and I look\nforward to many more together.",
    "Since today is your special day,\nI hope joy comes your way. Laughter,\nlove, and dreams come true.\nAll the best, just for you!",
    "Happy Birthday! Wishing you love,\nlaughter, and a year full of\nwonderful memories.",
    "Wishing you a day filled with happiness\nand a year filled with joy.\nHappy Birthday!",
    "生日快乐！愿你拥有幸福和健康，生活充满喜悦与美好。",
    "愿你岁岁平安，年年有今日，岁岁有今朝。生日快乐！"
  ],
  "CN": [
    "Wishing You a Happy & Prosperous\nLunar New Year!",
    "This year, I specially wish for you\na double dose of health and happiness,\ntopped with lots of good fortune. Have\na great year ahead!\nHappy Chinese New Year!",
    "Wishing you health, happiness,\nand prosperity in the year ahead.\nMay success and peace be with\nyou and your loved ones.\nHappy Chinese New Year!",
    "Wishing you and your family a promising\nand fulfilling Chinese New Year, filled\nwith peace, prosperity, and joy.",
    "新年快乐，恭喜发财，身体健康，万事如意！",
    "一帆风顺年年好，万事如意步步高！",
    "新年快乐！愿你新的一年幸福满满、好运连连！"
  ],
  "DS": [
    "With heartfelt condolences on\nthe demise of your beloved one",
    "Please accept my heartfelt condolences.\nMay you find peace and\nstrength in the days ahead.",
    "Please accept my heartfelt sorrow on\nthe demise of your beloved one.\nMy thoughts are with you\nand your family.",
    "Our sincere condolences on the demise\nof your beloved one. May you and\nyour family find strength and peace\nduring this difficult time.",
    "I am deeply sorry for your loss.\nMy thoughts and prayers are with you and\nyour family during this difficult time."
  ],
  "DV": [
    "Celebrating The Festival Of Lights,\nHappy Diwali !",
    "A very Happy & Bright Deepavali\nto you and your family.",
    "A very Happy & Prosperous Diwali to you !",
    "Wishing a warm and prosperous Diwali\nto you and your family.",
    "Wishing you and your family\na happy and safe Diwali.",
    "As we celebrate Diwali, let's hope that\nit brings us new success, prosperity,\nhealth, wealth and happiness."
  ],
  "FD": [
    "Happy Father's Day !!",
    "To the World's Greatest Dad,\nThanks for being my hero everyday",
    "Behind every great child\nis an Amazing Dad",
    "Thanks for all the\nDad jokes _ you're  pun - believeable !!",
    "Happy Father's Day to\nmy wonderful daddy.\nThanks for always being there for us."
  ],
  "FM": [
    "To my incredible friend,\nHappy Friendship Month! You bring\nso much joy, laughter, and love into\nmy life. So lucky to have you\nby my side.",
    "\You're the peanut butter\nto my jelly — weird but perfect.\nHappy Friendship Month  !!",
    "Happy Friendship Month to the person\nwho makes life brighter and better\njust by being in it.\nThank you for always being there .",
    "Happy Friendship Month!\nGrateful for the bond we share and\nthe countless memories we've made.\nHere to many more adventures together !",
    "\In the book of life, friends are\nthe most beautiful chapters.\nHappy Friendship Month !!"
  ],
  "HR": [
    "SELAMAT HARI RAYA AIDILFITRI !",
    "May the light of Hari Raya\niluminate your life and guide you to\npeace love and happiness",
    "SELAMAT HARI RAYA AIDILFITRI !\nMay all your sins be forgiven and\nyour prayers answered .",
    "SELAMAT HARI RAYA AIDILFITRI !\nMay your home be filled with joy and\nyour heart with forgiveness.",
    "May the spirit of Hari Raya fill\nyour heart with love ,\npeace and prosperity"
  ],
  "HW": [
    "Congratulations on your new home!\nWishing you nothing but happiness and\ngood times in your new space",
    "Home is where every story begins ,\nHere's to a beautiful new chapter !\n",
    "May your new home be filled with\nendless memorises and possibilites !"
  ],
  "MC": [
    "Happy Mid-Autumn Festival!",
    "May This Full Moon Light Up Your Life\nWith Good Luck and Prosperity.",
    "Wishing You A Happy and Prosperous\nMid-Autumn Festival!",
    "中秋快乐!",
    "祝你的事业和生活像那中秋的圆月一样，亮亮堂堂，圆圆满满",
    "中秋节快乐，万事如意，心想事成！"
  ],
  "MD": [
    "Mom, you're the best !\nHappy Mother's Day!\n",
    "Thank you for your immeasurable\ncontribution to my life.\nHappy Mother's Day!",
    "A mother's love is the heart of\nthe family and the soul of the home.\nHappy Mother Day !",
    "Thank you Mom for every sacrifice,\nevery smile and every moment of care.",
    "Thank you for being a wonderful mother\nand the very best kind of friend"
  ],
  "NB": [
    "Congratulations on your new baby!\nWishing your family love, joy, and\ncountless blessings. Enjoy every\nprecious moment!",
    "A new chapter begins!\nCongratulations on your little\nbundle of joy. Wishing your family\nendless love and happiness.",
    "Congratulations … It's is a Baby Boy ! /\nCongratulations … It's is a Baby Girl  !",
    "The world just got two amazing parents !\nCongratulations on your precious bundle!",
    "Wishing you endless joy, patience\nand love on this incredible new\njourney of parenthood"
  ],
  "ND": [
    "Happy Nurses Day !!",
    "Your hands bring healing, your heart\nbrings hope !  \n Thank you for your\nunwavering dedication and care.\nHappy Nurses Day !",
    "Not all Heroes wear cape,\nsome wear scrubs and make\nthe world better everyday.\nHappy Nurses Day !",
    "The world is a better place because of\npeople like u who choose heal, help and\nlove without limits.\nHappy Nurse Day !",
    "Your sacrifices and kindness\ndidn't go unnoticed.\nHappy Nurses Day to a true hero !"
  ],
  "OO": [
    "Congratulations & Best Wishes On The\nAuspicious Opening of your New Office.",
    "May your new business be filled\nwith endless growth and success !",
    "生意兴隆",
    "客似云来"
  ],
  "OT": [
    "Wishing you success in your exhibition!",
    "Congratulations & Best Wishes on your\ndinner and dance celebration!"
  ],
  "GD": [
    "Congratulations on your graduation!\nWishing you all the best in this\nexciting new chapter.",
    "You did it! So proud of you and\nexcited for what's next!",
    "Congratulations, Graduate! So proud\nof all you've accomplished! Here's\nto your bright future!",
    "Wishing you a future full of endless\npossibilities. Congratulations, and\nhere's to all the exciting things\nahead!"
  ],
  "RT": [
    "Congratulations on your retirement!\nWishing you all the happiness and\nrelaxation you deserve in this next\nchapter!",
    "Congratulations on your retirement.\nYou've earned every moment of rest\nand enjoyment that's coming your way!",
    "Thank you for your hard work and\ndedication over the years. Wishing\nyou nothing but happiness and\nrelaxation in your retirement!"
  ],
  "RM": [
    "Everytime I'm Near You,\nI'm In Cloud Nine!\nThank You For Being Mine.",
    "Thank You For Showing Me That\nThere Is Such A Thing As Happiness\nWith All Of My Heart,\nI Will Be Loving You.",
    "Today's A Very Special Day For Sending\nAll My Love Your Way!",
    "For Yesterday's Memories,\nToday's Love, And Tomorrow's Dreams\nI Love You.",
    "爱你  是我做过最对的事",
    "你是我心中唯一的风景"
  ],
  "SR": [
    "Hope each new day brings you closer\nto a full and speedy recovery",
    "Even superheroes need rest - take your\ntime to rest up and recharge.",
    "May the Lord's healing hand\nrest upon you and\nbring u strength comfort and peace.",
    "Even times of illness,\nGod is with you - guiding\nprotecting and healing you"
  ],
  "SW": [
    "Happy Secretaries's week",
    "You make hard work look effortless\nand everyday brighter.\nWe're lucky to have you !",
    "You're more than a secretary - you're a\nvital part of our successful team.\nHappy secretaries's week"
  ],
  "TD": [
    "Happy Teacher's Day!",
    "Teaching is one profession that\ncreates all other professions,\nThank you for everything that you do!",
    "To the world,\nyou may just be a teacher\nbut to your students, you are a hero",
    "老师您辛苦了 祝您教师节快乐 !!"
  ],
  "TY": [
    "We appreciate your continued partnership\nand trust. It's been a pleasure working\nwith you, and we look forward to growing\ntogether!",
    "Thank you for your continued support\nand trust.",
    "With sincere gratitude for your\nprofessionalism, kindness, and support.\nThank you!",
    "Thank you for your healing hands, caring\nheart, and unwavering dedication.",
    "With sincere appreciation for your care,\nstrength, and selfless service.\nThank you!"
  ],
  "VD": [
    "You're my today, my tomorrow\nand my always. Happy Valentine's Day",
    "In your arms I've found my home\nHappy Valentine's Day.",
    "Roses are red, violets are blue,\nyou snore like a bear..\nBut I still love you."
  ],
  "WF": [
    "It's been a pleasure working with you.\nBest of luck in your next chapter!",
    "Goodbyes are never easy, but I know this\nisn't the end. Wishing you all the best\non your new journey.",
    "Welcome aboard! We're excited to work\nwith you and hope you enjoy being part\nof our team.",
    "It's a pleasure to welcome you! We're\nexcited to have you with us and hope you\nenjoy your stay/event!",
    "A warm welcome and best wishes for a\ncomfortable, enjoyable, and memorable\nstay in Singapore."
  ],
  "WW": [
    "Wishing you both a wonderful journey\nfilled with love and joy.\nCongratulations on your wedding day !",
    "Here to the beginning of forever -\nmay your love grow stronger everyday.",
    "May your love story\ncontinue to unfold with beauty,\ngrace and adventure",
    "新婚快乐 幸福美满 !"
  ],
  "XM": [
    "Here's to a year of blessings\nand beyond. Have a Merry Christmas!",
    "Have a cheerful, holly, jolly, and\na very Merry Christmas and\na Happy New Year.",
    "May this Christmas bring you much\njoy and happiness, and may your\nNew Year be merry and bright.",
    "From our bubble to yours,\nwe wish you a very Merry Christmas and\na happy holiday season!",
    "May the spirit of Christmas\nfill your heart and home\nwith peace joy and love !"
  ]
};

showGiftMessageModal = (element, mode = 'Edit') => {
  const wrapper = element.closest('.jsc-cart-gift-message-wrapper');
  const cartItemRow = wrapper.closest('.cart-item');
  
  // Get the index from the cart item row's data-index attribute
  const cartItemIndex = cartItemRow.getAttribute('data-index');
  
  // Get the wrapper again to access its data attributes (now that we have the row)
  const cartGiftMsgWrapper = wrapper;
  
  const getMetafieldValue = (propertyName) => {
    const propertyElement = cartItemRow.querySelector(`[data-property="${propertyName}"] dd`);
    const value = propertyElement?.textContent?.trim() || '';
    return value;
  };

  const initial = getMetafieldValue('Initial');
  const nameForPersonalization = getMetafieldValue('Name For Personalisation');
  const recipientName = getMetafieldValue('Recipient Name');
  const giftMessage = getMetafieldValue('Gift Message');
  const senderName = getMetafieldValue('Sender Name');
  const occasion = getMetafieldValue('_Occasion');
  const langFrom = getMetafieldValue('_lang_from') || 'EN';
  const langTo = getMetafieldValue('_lang_to') || 'EN';
  const langMsg = getMetafieldValue('_lang_msg') || 'EN';
  const initialsMaxLength = cartGiftMsgWrapper.getAttribute('data-initials-max-length') || '40';
  const recipientNameMaxLength = cartGiftMsgWrapper.getAttribute('data-recipient-name-max-length') || '105';
  const senderNameMaxLength = cartGiftMsgWrapper.getAttribute('data-sender-name-max-length') || '105';
  const messageMaxLength = cartGiftMsgWrapper.getAttribute('data-message-max-length') || '160';
  const showInitial = cartGiftMsgWrapper.getAttribute('data-show-initial') === 'true';
  const nameForPersonalisationMaxLength = cartGiftMsgWrapper.getAttribute('data-name-for-personalisation-max-length') || '40';
  const showNameForPersonalisation = cartGiftMsgWrapper.getAttribute('data-show-name-for-personalisation') === 'true';
  const modal = document.getElementById('jsc-gift-message-modal');

  if (!modal) {
    console.error('Modal element not found in DOM');
    return;
  }

  try {
    modal.style.display = 'flex';
    modal.setAttribute('data-index', cartItemIndex);
    
    // Update modal title based on mode
    const modalTitle = modal.querySelector('.jsc-modal-title');
    if (modalTitle) {
      modalTitle.textContent = mode === 'Add' ? 'Add Gift Message' : 'Edit Gift Message';
    }
    
    renderGiftMessageModalForm({
      initialsMaxLength,
      recipientNameMaxLength,
      senderNameMaxLength,
      messageMaxLength,
      showInitial,
      initial,
      nameForPersonalisationMaxLength,
      showNameForPersonalisation,
      nameForPersonalization,
      recipientName,
      giftMessage,
      senderName,
      occasion,
      langFrom,
      langTo,
      langMsg
    });
  } catch (error) {
    console.error('Error showing gift message modal:', error);
  }
}

renderGiftMessageModalForm = (config) => {
  const container = document.getElementById('jsc-modal-gift-message-container');
  if (!container) {
    console.error('Modal container not found');
    return;
  }
  
  let formHTML = '<div class="jsc-gift-message">';
  
  if (config.showInitial) {
    formHTML += `
      <div class="form-field">
        <label for="initial-modal" class="form-label">Initial:</label>
        <input 
          type="text" 
          id="initial-modal" 
          name="properties[Initial]" 
          placeholder="Enter initials"
          value="${config.initial || ''}"
          maxlength="${config.initialsMaxLength}"
        >
        <div class="jsc-gift-msg-text-counter">
          <span class="jsc-gift-msg-text-count">${config.initial ? config.initial.length : 0}</span>/${config.initialsMaxLength}
        </div>
      </div>
    `;
  }
  
  if (config.showNameForPersonalisation) {
    formHTML += `
      <div class="form-field">
        <label for="name-for-personalisation-modal" class="form-label">Name For Personalisation:</label>
        <input 
          type="text" 
          id="name-for-personalisation-modal" 
          name="properties[Name For Personalisation]" 
          placeholder="Enter Name For Personalisation"
          value="${config.nameForPersonalization || ''}"
          maxlength="${config.nameForPersonalisationMaxLength}"
        >
        <div class="jsc-gift-msg-text-counter">
          <span class="jsc-name-for-personalisation-count">${config.nameForPersonalization ? config.nameForPersonalization.length : 0}</span>/${config.nameForPersonalisationMaxLength}
        </div>
      </div>
    `;
  }
  
  const recipientNamePreview = (config.recipientName || '').replace(/\n/g, '<br/>');
  formHTML += `
    <div class="form-field">
      <label for="recipient-name-modal" class="form-label">Recipient Name:</label>
      <textarea
        id="recipient-name-modal"
        name="properties[Recipient Name]"
        class="form-textarea"
        placeholder="Enter recipient name"
        maxlength="${config.recipientNameMaxLength}"
        rows="3"
      >${config.recipientName || ''}</textarea>
      <div class="jsc-gift-msg-line-text-counter">
        <span class="jsc-recipient-name-line-text-count">0</span>
      </div>
      <div class="jsc-gift-msg-text-counter">
        <span class="jsc-recipient-name-count">${config.recipientName ? config.recipientName.length : 0}</span>/${config.recipientNameMaxLength}
      </div>
    </div>
  `;
  
  formHTML += `
    <div class="form-field">
      <label for="occasion-modal" class="form-label">Occasion: <span style="color: #d32f2f;">*</span></label>
      <div class="jsc-occasion-dropdowns">
        <select id="occasion-modal" name="properties[_Occasion]" class="form-select">
          <option value="">Select an occasion</option>
        </select>
        <select id="gift-message-ideas-modal" class="form-select">
          <option value="">Gift Message Ideas</option>
        </select>
      </div>
    </div>
  `;
  
  formHTML += `
    <div class="form-field">
      <label for="gift-message-modal" class="form-label">Message:</label>
      <textarea 
        id="gift-message-modal" 
        name="properties[Gift Message]" 
        class="form-textarea" 
        placeholder="Enter your gift message"
        maxlength="${config.messageMaxLength}"
        rows="6"
      >${config.giftMessage || ''}</textarea>
      <div class="jsc-gift-msg-line-text-counter">
        <span class="jsc-gift-msg-line-text-count">0</span>
      </div>
      <div class="jsc-gift-msg-text-counter">
        <span class="jsc-gift-msg-text-count">${config.giftMessage ? config.giftMessage.length : 0}</span>/${config.messageMaxLength}
      </div>
    </div>
  `;
  
  const senderNamePreview = (config.senderName || '').replace(/\n/g, '<br/>');
  formHTML += `
    <div class="form-field">
      <label for="sender-name-modal" class="form-label">Sender Name:</label>
      <textarea
        id="sender-name-modal"
        name="properties[Sender Name]"
        class="form-textarea"
        placeholder="Enter your name"
        maxlength="${config.senderNameMaxLength}"
        rows="3"
      >${config.senderName || ''}</textarea>
      <div class="jsc-gift-msg-line-text-counter">
        <span class="jsc-sender-name-line-text-count">0</span>
      </div>
      <div class="jsc-gift-msg-text-counter">
        <span class="jsc-sender-name-count">${config.senderName ? config.senderName.length : 0}</span>/${config.senderNameMaxLength}
      </div>
    </div>
  `;

  // start: Message Preview
  formHTML += `
    <div class="form-field">
      <label class="form-label">Preview:</label>
      <div class="gift-message-preview">
        <div id="message-preview-recipient">${config.recipientName ? "To: <b>" + recipientNamePreview + "</b>" : ""}</div>
        <div id="message-preview-message">${config.giftMessage || ""}</div>
        <div id="message-preview-sender">${config.senderName ? "From, <br/>" + senderNamePreview : ""}</div>
      </div>
    </div>
  `;
  // end: Message Preview
  
  formHTML += `
    <!-- Hidden language fields -->
    <input type="hidden" id="lang-msg-modal" name="properties[_lang_msg]" value="${config.langMsg || 'EN'}">
    <input type="hidden" id="lang-from-modal" name="properties[_lang_from]" value="${config.langFrom || 'EN'}">
    <input type="hidden" id="lang-to-modal" name="properties[_lang_to]" value="${config.langTo || 'EN'}">
  `;
  
  formHTML += '</div>';
  
  container.innerHTML = formHTML;
  
  populateOccasionDropdown(config.occasion || '');
  initializeModalFunctionality();
}

populateOccasionDropdown = (selectedOccasion = '') => {
  const occasionSelect = document.getElementById('occasion-modal');
  if (!occasionSelect) return;
  
  // Trim the selected occasion value to ensure proper matching
  const trimmedSelectedOccasion = selectedOccasion ? selectedOccasion.trim() : '';
  
  const occasions = 'AN:Anniversary,BD:Bosses Day,BH:Birthday,CN:Chinese New Year,DS:Condolences,DV:Deepavali,FD:Fathers Day,FM:Friendship,GD:Graduation,HR:Hari Raya,HW:Housewarming,MC:Mid-Autumn Festival,MD:Mothers Day,NB:Newborn,ND:Nurses Day,OO:Official Opening,OT:Other,RM:Romance,RT:Retirement,SR:Speedy Recovery,SW:Secretarys Week,TD:Teachers Day,TY:Thank You,VD:Valentines Day,WF:Welcome / Farewell,WW:Wedding Wishes,XM:Christmas';
  
  occasions.split(',').forEach(occasion => {
    const [code, name] = occasion.split(':');
    const option = document.createElement('option');
    option.value = code;
    option.textContent = name;
    if (trimmedSelectedOccasion && code === trimmedSelectedOccasion) {
      option.selected = true;
    }
    occasionSelect.appendChild(option);
  });
  
  // If an occasion is prefilled, populate the gift message ideas dropdown
  if (trimmedSelectedOccasion && giftMessagesData[trimmedSelectedOccasion]) {
    const giftMessageIdeasSelect = document.getElementById('gift-message-ideas-modal');
    if (giftMessageIdeasSelect) {
      giftMessageIdeasSelect.innerHTML = '<option value="">Gift Message Ideas</option>';
      const messages = giftMessagesData[trimmedSelectedOccasion];
      
      messages.forEach((message, index) => {
        const option = document.createElement('option');
        option.value = index + 1;
        option.textContent = message;
        giftMessageIdeasSelect.appendChild(option);
      });
    }
  }
}

closeGiftMessageModal = () => {
  document.getElementById('jsc-gift-message-modal').style.display = 'none';
}

saveGiftMessage = () => {
  const modal = document.getElementById('jsc-gift-message-modal');
  const cartItemIndex = modal.getAttribute('data-index');
  
  if (!cartItemIndex) {
    alert('Error: Cannot save gift message. Please try again.');
    return;
  }
  
  // Validate occasion field
  const form = document.getElementById('jsc-gift-message-form');
  const occasionField = form.querySelector('select[name="properties[_Occasion]"]');

  if (!occasionField || !occasionField.value) {
    const existingError = form.querySelector('.jsc-occasion-validation-error');

    if (existingError) existingError.remove();
    
    const errorElement = document.createElement('div');
    errorElement.className = 'jsc-occasion-validation-error';
    errorElement.style.cssText = 'color: #d32f2f; margin-top: 15px; padding: 10px; background-color: #ffebee; border-radius: 4px; font-size: 14px;';
    errorElement.textContent = 'The Occasion field is required. Please make a selection before adding to cart.';
    
    const occasionFieldContainer = occasionField.closest('.form-field');
    if (occasionFieldContainer) {
      occasionFieldContainer.insertAdjacentElement('afterend', errorElement);
    } else {
      form.insertBefore(errorElement, form.firstChild);
    }
    
    // Remove error after 5 seconds
    setTimeout(function() {
      if (errorElement && errorElement.parentNode) {
        errorElement.style.transition = 'opacity 0.3s';
        errorElement.style.opacity = '0';
        setTimeout(function() {
          errorElement.remove();
        }, 300);
      }
    }, 5000);
    
    return;
  }
  
  closeGiftMessageModal();
  cartItemStartLoading(cartItemIndex);
  
  // Get quantity from DOM
  const mainCartElement = document.querySelector('main-cart');
  const sectionId = mainCartElement ? FoxTheme.utils.getSectionId(mainCartElement) : null;
  const quantityInput = document.getElementById(`Quantity-${sectionId}-${cartItemIndex}`);
  const quantity = parseInt(quantityInput.value) || 1;
  
  // Get cart item row from DOM to preserve other properties
  const mainCart = sectionId ? document.querySelector(`#MainCart-${sectionId}`) : null;
  const cartItemRow = mainCart ? mainCart.querySelector(`.cart-item[data-index="${cartItemIndex}"]`) : null;
  
  // Build updated properties - preserve all existing properties from DOM
  const updatedProperties = {};
  
  if (cartItemRow) {
    const propertyElements = cartItemRow.querySelectorAll('[data-property]');
    propertyElements.forEach(propEl => {
      const propertyName = propEl.getAttribute('data-property');
      const propertyValue = propEl.querySelector('dd')?.textContent?.trim() || '';
      
      // Skip gift message related properties - we'll set them from form data
      const giftMessageKeys = ['Initial', 'Name For Personalisation', 'Recipient Name', 'Gift Message', 'Sender Name', '_Occasion', '_lang_msg', '_lang_from', '_lang_to'];
      if (!giftMessageKeys.includes(propertyName)) {
        updatedProperties[propertyName] = propertyValue;
      }
    });
  }
  
  // Get form data
  const formData = new FormData(form);
  
  const giftData = {
    initial: formData.get('properties[Initial]') || '',
    nameForPersonalization: formData.get('properties[Name For Personalisation]') || '',
    recipientName: formData.get('properties[Recipient Name]') || '',
    giftMessage: formData.get('properties[Gift Message]') || '',
    senderName: formData.get('properties[Sender Name]') || '',
    occasion: formData.get('properties[_Occasion]') || '',
    langMsg: formData.get('properties[_lang_msg]') || 'EN',
    langFrom: formData.get('properties[_lang_from]') || 'EN',
    langTo: formData.get('properties[_lang_to]') || 'EN'
  };
  
  // Add gift message properties from form data
  if (giftData.initial) {
    updatedProperties['Initial'] = giftData.initial;
  }

  if (giftData.nameForPersonalization) {
    updatedProperties['Name For Personalisation'] = giftData.nameForPersonalization;
  }
  
  if (giftData.recipientName) {
    updatedProperties['Recipient Name'] = giftData.recipientName;
  }
  
  if (giftData.giftMessage) {
    updatedProperties['Gift Message'] = giftData.giftMessage;
  }
  
  if (giftData.senderName) {
    updatedProperties['Sender Name'] = giftData.senderName;
  }
  
  if (giftData.occasion) {
    updatedProperties['_Occasion'] = giftData.occasion;
  }
  
  // Always include language fields from form data (prefilled from cart item properties)
  updatedProperties['_lang_to'] = giftData.langTo;
  updatedProperties['_lang_msg'] = giftData.langMsg;
  updatedProperties['_lang_from'] = giftData.langFrom;
  
  CartJS.updateItem(cartItemIndex, quantity, updatedProperties)
    .then(data => {
      console.log('Cart updated successfully.');
      return refreshMainCartSection();
    })
    .then(() => {
      cartItemCompleteLoading(cartItemIndex);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      cartItemCompleteLoading(cartItemIndex);
    });
}

removeGiftMessage = () => {
  const modal = document.getElementById('jsc-gift-message-modal');
  const cartItemIndex = modal.getAttribute('data-index');
  
  if (!cartItemIndex) {
    alert('Error: Cannot remove gift message. Please try again.');
    return;
  }
  
  closeGiftMessageModal();
  cartItemStartLoading(cartItemIndex);
  
  // Get quantity from DOM
  const mainCartElement = document.querySelector('main-cart');
  const sectionId = mainCartElement ? FoxTheme.utils.getSectionId(mainCartElement) : null;
  const quantityInput = sectionId ? document.getElementById(`Quantity-${sectionId}-${cartItemIndex}`) : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  
  // Get cart item row from DOM
  const mainCart = sectionId ? document.querySelector(`#MainCart-${sectionId}`) : null;
  const cartItemRow = mainCart ? mainCart.querySelector(`.cart-item[data-index="${cartItemIndex}"]`) : null;
  
  if (!cartItemRow) {
    console.error('Cart item row not found for index:', cartItemIndex);
    cartItemCompleteLoading(cartItemIndex);
    return;
  }
  
  // Get all properties from DOM (from data-property elements)
  const updatedProperties = {};
  const propertyElements = cartItemRow.querySelectorAll('[data-property]');
  
  propertyElements.forEach(propEl => {
    const propertyName = propEl.getAttribute('data-property');
    const propertyValue = propEl.querySelector('dd')?.textContent?.trim() || '';
    
    // Skip gift message related properties - we'll set them to empty
    const giftMessageKeys = ['Initial', 'Name For Personalisation', 'Recipient Name', 'Gift Message', 'Sender Name', '_Occasion', '_lang_msg', '_lang_from', '_lang_to'];
    const trimmedKey = propertyName?.trim();
    
    if (!giftMessageKeys.includes(trimmedKey)) {
      // Preserve non-gift-message properties
      updatedProperties[propertyName] = propertyValue;
    }
  });
  
  // Set all gift message properties to empty
  const giftMessageKeys = ['Initial', 'Name For Personalisation', 'Recipient Name', 'Gift Message', 'Sender Name', '_Occasion', '_lang_msg', '_lang_from', '_lang_to'];
  giftMessageKeys.forEach(key => {
    updatedProperties[key] = '';
  });
  
  CartJS.updateItem(cartItemIndex, quantity, updatedProperties)
    .then(data => {
      console.log('Cart updated successfully.');
      return refreshMainCartSection();
    })
    .then(() => {
      cartItemCompleteLoading(cartItemIndex);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      cartItemCompleteLoading(cartItemIndex);
    });
}

// Function to detect language based on Han script
detectLanguage = (text) => {
  if (!text) return 'EN';
  return /\p{Script=Han}/u.test(text) ? 'ZH' : 'EN';
}

// Function to update language hidden fields
updateModalLanguageFields = (fieldType, value) => {
  const langFieldMap = {
    'message': '_lang_msg',
    'sender': '_lang_from',
    'recipient': '_lang_to'
  };
  const langFieldName = langFieldMap[fieldType];
  if (!langFieldName) return;
  
  const langField = document.querySelector(`input[name="properties[${langFieldName}]"]`);
  if (langField) {
    langField.value = detectLanguage(value);
  }
}

const GIFT_MSG_MAX_LINE_LENGTH = 40;

function getGiftMessageLineInfo(textarea) {
  const value = textarea.value;
  const cursorPosition = textarea.selectionStart;
  const lineIndex = value.substring(0, cursorPosition).split('\n').length - 1;
  const lines = value.split('\n');
  return {
    lineNumber: lineIndex + 1,
    lineLength: (lines[lineIndex] || '').length
  };
}

function updateGiftMessageLineCounter(lineCounterEl, textarea, maxLineLength = GIFT_MSG_MAX_LINE_LENGTH) {
  if (!lineCounterEl) return;
  const lineInfo = getGiftMessageLineInfo(textarea);
  lineCounterEl.textContent = `Line ${lineInfo.lineNumber} - ${lineInfo.lineLength}/${maxLineLength}`;
}

function truncateGiftMessageLines(textarea, maxLineLength = GIFT_MSG_MAX_LINE_LENGTH) {
  const lines = textarea.value.split('\n');
  let modified = false;
  const truncatedLines = lines.map((line) => {
    if (line.length > maxLineLength) {
      modified = true;
      return line.substring(0, maxLineLength);
    }
    return line;
  });

  if (modified) {
    const cursorPosition = textarea.selectionStart;
    textarea.value = truncatedLines.join('\n');
    const newCursorPosition = Math.min(cursorPosition, textarea.value.length);
    textarea.setSelectionRange(newCursorPosition, newCursorPosition);
  }
}

function filterGiftMessageInput(value) {
  return value.replace(/~/g, '').replace(/[^a-zA-Z0-9\p{Script=Han}\s\p{P}\p{S}]/gu, '');
}

function enforceGiftMessageMaxLines(textarea, maxLines) {
  const lines = textarea.value.split('\n');
  if (lines.length > maxLines) {
    textarea.value = lines.slice(0, maxLines).join('\n');
  }
}

function setupGiftMessageMultilineField(field, options = {}) {
  const {
    lineCounterEl,
    charCountEl,
    maxLineLength = GIFT_MSG_MAX_LINE_LENGTH,
    maxLines = 3,
    onInput
  } = options;

  if (!field) return;

  function applyLimits() {
    const filteredValue = filterGiftMessageInput(field.value);
    if (field.value !== filteredValue) {
      const cursorPosition = field.selectionStart;
      field.value = filteredValue;
      const newCursorPosition = Math.min(cursorPosition, field.value.length);
      field.setSelectionRange(newCursorPosition, newCursorPosition);
    }

    truncateGiftMessageLines(field, maxLineLength);
    enforceGiftMessageMaxLines(field, maxLines);

    if (charCountEl) {
      charCountEl.textContent = field.value.length;
    }
    updateGiftMessageLineCounter(lineCounterEl, field, maxLineLength);
    if (onInput) onInput(field.value);
  }

  field.addEventListener('input', applyLimits);
  field.addEventListener('keyup', () => updateGiftMessageLineCounter(lineCounterEl, field, maxLineLength));
  field.addEventListener('click', () => updateGiftMessageLineCounter(lineCounterEl, field, maxLineLength));
  field.addEventListener('mouseup', () => updateGiftMessageLineCounter(lineCounterEl, field, maxLineLength));
  field.addEventListener('focus', () => updateGiftMessageLineCounter(lineCounterEl, field, maxLineLength));

  if (field.value) {
    applyLimits();
  }
}

updateMessagePreview = (fieldType, value) => {
  const idFieldMap = {
    'message': 'message-preview-message',
    'sender': 'message-preview-sender',
    'recipient': 'message-preview-recipient'
  };

  const id = idFieldMap[fieldType];
  if (!id) return;

  const previewField = document.getElementById(id);
  if(previewField){
    if(fieldType === 'recipient') {
      previewField.innerHTML = value ? "To: <b>" + value + "</b>" : "";
    }
    else if (fieldType == 'sender'){ 
      previewField.innerHTML = value? "From, <br/>" + value : "";
    }
    else {
      previewField.innerHTML = value || "";
    }
  }
}

initializeModalFunctionality = () => {
  const initialInput = document.getElementById('initial-modal');
  if (initialInput) {
    const initialCount = initialInput.parentElement.querySelector('.jsc-gift-msg-text-count');
    if (initialCount) {
      initialInput.addEventListener('input', function() {
        initialCount.textContent = this.value.length;
      });
    }
  }

  const nameForPersonalisationInput = document.getElementById('name-for-personalisation-modal');
  if (nameForPersonalisationInput) {
    const nameForPersonalisationCount = nameForPersonalisationInput.parentElement.querySelector('.jsc-name-for-personalisation-count');
    if (nameForPersonalisationCount) {
      nameForPersonalisationInput.addEventListener('input', function() {
        nameForPersonalisationCount.textContent = this.value.length;
      });
    }
  }
  
  const recipientNameInput = document.getElementById('recipient-name-modal');
  if (recipientNameInput) {
    setupGiftMessageMultilineField(recipientNameInput, {
      lineCounterEl: recipientNameInput.parentElement.querySelector('.jsc-recipient-name-line-text-count'),
      charCountEl: recipientNameInput.parentElement.querySelector('.jsc-recipient-name-count'),
      maxLines: 3,
      onInput: (value) => {
        updateModalLanguageFields('recipient', value);
        updateMessagePreview('recipient', value.replace(/\n/g, '<br/>'));
      }
    });
  }

  const senderNameInput = document.getElementById('sender-name-modal');
  if (senderNameInput) {
    setupGiftMessageMultilineField(senderNameInput, {
      lineCounterEl: senderNameInput.parentElement.querySelector('.jsc-sender-name-line-text-count'),
      charCountEl: senderNameInput.parentElement.querySelector('.jsc-sender-name-count'),
      maxLines: 3,
      onInput: (value) => {
        updateModalLanguageFields('sender', value);
        updateMessagePreview('sender', value.replace(/\n/g, '<br/>'));
      }
    });
  }
  
  const giftMessageInput = document.getElementById('gift-message-modal');
  const giftMessageIdeasSelect = document.getElementById('gift-message-ideas-modal');
  const occasionSelect = document.getElementById('occasion-modal');
  
  if (giftMessageInput) {
    const charCount = giftMessageInput.parentElement.querySelector('.jsc-gift-msg-text-count');
    const lineCounter = giftMessageInput.parentElement.querySelector('.jsc-gift-msg-line-text-count');
    
    function updateLineCounter(textarea) {
      updateGiftMessageLineCounter(lineCounter, textarea);
    }
    
    // Function to automatically truncate lines exceeding 40 characters
    function truncateMessageLines(textarea) {
      const maxLineLength = 40;
      const lines = textarea.value.split('\n');
      let modified = false;
      
      // Truncate each line to max 40 characters
      const truncatedLines = lines.map(line => {
        if (line.length > maxLineLength) {
          modified = true;
          return line.substring(0, maxLineLength);
        }
        return line;
      });
      
      // Update textarea value if any line was truncated
      if (modified) {
        const cursorPosition = textarea.selectionStart;
        textarea.value = truncatedLines.join('\n');
        
        // Restore cursor position (adjust if cursor was in truncated area)
        const newCursorPosition = Math.min(cursorPosition, textarea.value.length);
        textarea.setSelectionRange(newCursorPosition, newCursorPosition);
        
        // Update character count
        if (charCount) {
          charCount.textContent = textarea.value.length;
        }
        
        updateGiftMessageLineCounter(lineCounter, textarea);
      }
    }
    
    if (charCount) {
      giftMessageInput.addEventListener('input', function() {
        const filteredValue = this.value.replace(/~/g, '').replace(/[^a-zA-Z0-9\p{Script=Han}\s\p{P}\p{S}]/gu, '');
        if (this.value !== filteredValue) {
          const cursorPosition = this.selectionStart;
          this.value = filteredValue;
          const newCursorPosition = Math.min(cursorPosition, this.value.length);
          this.setSelectionRange(newCursorPosition, newCursorPosition);
        }
        charCount.textContent = this.value.length;
        // Automatically truncate lines exceeding 40 characters
        truncateMessageLines(this);
        // Update line counter
        updateLineCounter(this);
        // Update language field
        updateModalLanguageFields('message', this.value);
        updateMessagePreview('message', this.value.replace(/\n/g, "<br/>"));
      });
    }
    
    // Update line counter on cursor movement
    giftMessageInput.addEventListener('keyup', function() {
      updateLineCounter(this);
    });
    
    giftMessageInput.addEventListener('click', function() {
      updateLineCounter(this);
    });
    
    giftMessageInput.addEventListener('mouseup', function() {
      updateLineCounter(this);
    });
    
    // Initialize line counter on focus
    giftMessageInput.addEventListener('focus', function() {
      updateLineCounter(this);
    });
  }
  
  if (occasionSelect && giftMessageIdeasSelect && giftMessageInput) {
    // Trigger change event if occasion is already selected (when editing)
    if (occasionSelect.value) {
      const changeEvent = new Event('change', { bubbles: true });
      occasionSelect.dispatchEvent(changeEvent);
    }
    
    occasionSelect.addEventListener('change', function() {
      const selectedOccasion = this.value;
      giftMessageIdeasSelect.innerHTML = '<option value="">Gift Message Ideas</option>';
      
      if (selectedOccasion && giftMessagesData[selectedOccasion]) {
        const messages = giftMessagesData[selectedOccasion];
        
        messages.forEach((message, index) => {
          const option = document.createElement('option');
          option.value = index + 1;
          option.textContent = message;
          giftMessageIdeasSelect.appendChild(option);
        });
      }
    });
    
    giftMessageIdeasSelect.addEventListener('change', function() {
      if (this.value && giftMessageInput) {
        const selectedMessage = this.options[this.selectedIndex].textContent;
        giftMessageInput.value = selectedMessage;
        const charCount = giftMessageInput.parentElement.querySelector('.jsc-gift-msg-text-count');
        if (charCount) {
          charCount.textContent = selectedMessage.length;
        }
        // Truncate lines exceeding 40 characters when message is populated from ideas
        const maxLineLength = 40;
        const lines = giftMessageInput.value.split('\n');
        const truncatedLines = lines.map(line => {
          return line.length > maxLineLength ? line.substring(0, maxLineLength) : line;
        });
        giftMessageInput.value = truncatedLines.join('\n');
        if (charCount) {
          charCount.textContent = giftMessageInput.value.length;
        }
        updateGiftMessageLineCounter(
          giftMessageInput.parentElement.querySelector('.jsc-gift-msg-line-text-count'),
          giftMessageInput
        );
        // Update language field
        updateModalLanguageFields('message', giftMessageInput.value);
        updateMessagePreview('message', giftMessageInput.value.replace(/\n/g, "<br/>"));
      }
    });
  }
  
  if (giftMessageInput) {
    const maxLines = 6;
    giftMessageInput.addEventListener('input', () => {
      const lines = giftMessageInput.value.split('\n');
      if (lines.length > maxLines) {
        giftMessageInput.value = lines.slice(0, maxLines).join('\n');
      }
    });
  }
}

// document.addEventListener('click', function(event) {
//   const modal = document.getElementById('jsc-gift-message-modal');
//   if (event.target === modal) {
//     closeGiftMessageModal();
//   }
// });

cartItemStartLoading = (cartItemIndex = null) => {
  const mainCartElement = document.querySelector('main-cart');
  if (!mainCartElement) {
    console.warn('Main cart element not found');
    return;
  }

  const sectionId = FoxTheme.utils.getSectionId(mainCartElement);
  const mainCart = document.querySelector(`#MainCart-${sectionId}`);
  
  if (!mainCart) {
    console.warn(`Main cart container #MainCart-${sectionId} not found`);
    return;
  }

  let loadersToShow = [];
  
  if (cartItemIndex) {
    const cartItemRow = mainCart.querySelector(`.cart-item[data-index="${cartItemIndex}"]`);
    
    if (cartItemRow) {
      const loaders = document.querySelectorAll(`#Loader-${sectionId}-${cartItemIndex}`);
      loadersToShow.push(...Array.from(loaders));
    } else {
      console.warn(`Cart item with index "${cartItemIndex}" not found, showing all loaders`);
      const cartItems = mainCart.querySelectorAll('.cart-item');
      cartItems.forEach((item) => {
        const itemIndex = item.getAttribute('data-index');
        if (itemIndex) {
          const loaders = document.querySelectorAll(`#Loader-${sectionId}-${itemIndex}`);
          loadersToShow.push(...Array.from(loaders));
        }
      });
    }
  } else {
    const cartItems = mainCart.querySelectorAll('.cart-item');
    cartItems.forEach((item) => {
      const itemIndex = item.getAttribute('data-index');
      if (itemIndex) {
        const loaders = document.querySelectorAll(`#Loader-${sectionId}-${itemIndex}`);
        loadersToShow.push(...Array.from(loaders));
      }
    });
  }

  loadersToShow.forEach((loader) => {
    loader.classList.add('btn--loading');
  });
}

cartItemCompleteLoading = (cartItemIndex = null) => {
  const mainCartElement = document.querySelector('main-cart');
  const sectionId = FoxTheme.utils.getSectionId(mainCartElement);
  const mainCart = document.querySelector(`#MainCart-${sectionId}`);
  
  if (!mainCart) {
    console.warn(`Main cart container #MainCart-${sectionId} not found`);
    return;
  }

  let loadersToHide = [];
  
  if (cartItemIndex) {
    const cartItemRow = mainCart.querySelector(`.cart-item[data-index="${cartItemIndex}"]`);
    
    if (cartItemRow) {
      const loaders = document.querySelectorAll(`#Loader-${sectionId}-${cartItemIndex}`);
      loadersToHide.push(...Array.from(loaders));
    } else {
      const cartItems = mainCart.querySelectorAll('.cart-item');
      cartItems.forEach((item) => {
        const itemIndex = item.getAttribute('data-index');
        if (itemIndex) {
          const loaders = document.querySelectorAll(`#Loader-${sectionId}-${itemIndex}`);
          loadersToHide.push(...Array.from(loaders));
        }
      });
    }
  } else {
    const cartItems = mainCart.querySelectorAll('.cart-item');
    cartItems.forEach((item) => {
      const itemIndex = item.getAttribute('data-index');
      if (itemIndex) {
        const loaders = document.querySelectorAll(`#Loader-${sectionId}-${itemIndex}`);
        loadersToHide.push(...Array.from(loaders));
      }
    });
  }

  loadersToHide.forEach((loader) => {
    loader.classList.remove('btn--loading');
  });
}

checkHospitalCodeExists = () => {
  const cartContainer = document.querySelector('.cart');
  if (!cartContainer) {
    return;
  }

  const hospitalPostalCodeList = FoxTheme?.settings?.multishippingHospitalPostalCodeList;
  if (!hospitalPostalCodeList) {
    cartContainer.setAttribute('data-hospital-code-exist', 'false');
    return;
  }

  // Split the list by comma and trim each entry
  const hospitalCodes = hospitalPostalCodeList.split(',').map(code => code.trim()).filter(code => code.length > 0);
  
  // Get all cart items
  const cartItems = document.querySelectorAll('.cart-item[data-key]');
  let hospitalCodeExists = false;
  
  for (const cartItem of cartItems) {
    // Find the postal code from hidden property elements
    const zipProperty = cartItem.querySelector('[data-property="_address_zip"]');
    if (zipProperty) {
      const postalCode = zipProperty.querySelector('dd')?.textContent?.trim() || '';
      
      if (postalCode) {
        // Check if postal code matches any hospital postal code (prefix matching)
        for (const hospitalCode of hospitalCodes) {
          if (postalCode.startsWith(hospitalCode)) {
            hospitalCodeExists = true;
            break;
          }
        }
        
        if (hospitalCodeExists) {
          break;
        }
      }
    }
  }
  
  cartContainer.setAttribute('data-hospital-code-exist', hospitalCodeExists ? 'true' : 'false');
}

refreshMainCartSection = async () => {
  const mainCartElement = document.querySelector('main-cart');
  if (!mainCartElement) {
    console.warn('Main cart element not found');
    return;
  }

  const sectionId = FoxTheme.utils.getSectionId(mainCartElement);
  const mainCart = document.querySelector(`#MainCart-${sectionId}`);
  
  if (!mainCart) {
    console.warn(`Main cart container #MainCart-${sectionId} not found`);
    return;
  }

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const response = await fetch(`${FoxTheme.routes.root_url}?section_id=${sectionId}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch section: ${response.status}`);
    }

    const responseText = await response.text();
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(responseText, 'text/html');
    const updatedMainCart = parsedHTML.querySelector(`#MainCart-${sectionId}`);
    
    if (updatedMainCart) {
      mainCart.innerHTML = updatedMainCart.innerHTML;

      const cartContainer = mainCart.closest('.cart');
      if (cartContainer) {
        // Update cart header (contains multishipping snippet)
        const cartHeader = cartContainer.querySelector('.cart__header');
        const updatedCartHeader = parsedHTML.querySelector('.cart__header');
        if (cartHeader && updatedCartHeader) {
          cartHeader.innerHTML = updatedCartHeader.innerHTML;
        }
        
        const cartForm = cartContainer.querySelector('.cart__form');
        const cartFooter = cartContainer.querySelector('.cart__footer');
        const cartEmpty = cartContainer.querySelector('.cart__empty');
        const isCartEmpty = !updatedMainCart.querySelector('.cart-item');
        
        if (isCartEmpty) {
          cartContainer.classList.add('is-empty');
          if (cartForm) cartForm.classList.add('hidden');
          if (cartFooter) cartFooter.classList.add('hidden');
          if (cartEmpty) cartEmpty.classList.remove('hidden');
        } else {
          cartContainer.classList.remove('is-empty');
          if (cartForm) cartForm.classList.remove('hidden');
          if (cartFooter) cartFooter.classList.remove('hidden');
          if (cartEmpty) cartEmpty.classList.add('hidden');
        }
        
        // Check for hospital codes after cart update
        checkHospitalCodeExists();
        // Check if only 1 main item remains and remove multishipping if so
        checkAndRemoveMultishippingIfSingleItem();
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            cart: null,
          },
        })
      );
    } else {
      const cartContainer = mainCart.closest('.cart');
      if (cartContainer) {
        cartContainer.classList.add('is-empty');
        const cartForm = cartContainer.querySelector('.cart__form');
        const cartFooter = cartContainer.querySelector('.cart__footer');
        const cartEmpty = cartContainer.querySelector('.cart__empty');
        if (cartForm) cartForm.classList.add('hidden');
        if (cartFooter) cartFooter.classList.add('hidden');
        if (cartEmpty) cartEmpty.classList.remove('hidden');
      }
    }
  } catch (error) {
    console.error('Error refreshing main cart section:', error);
    throw error;
  }
}
// end: Gift Message - Templates & Modal

// start: Address Modal Functions
showAddressModal = (element, mode = 'Edit') => {
  const addressWrapper = element.closest('.jsc-multishipping-address-wrapper');
  let cartItemRow = null;
  let cartItemIndex = null;
  
  if (addressWrapper) {
    cartItemIndex = addressWrapper.getAttribute('data-cart-item-index');
    
    if (cartItemIndex) {
      cartItemRow = document.querySelector(`.cart-item[data-index="${cartItemIndex}"]`);
    }
  }
  
  if (!cartItemRow || !cartItemIndex) {
    console.error('Cart item row not found');
    return;
  }
  
  const getMetafieldValue = (propertyName) => {
    const propertyElement = cartItemRow.querySelector(`[data-property="${propertyName}"] dd`);
    const value = propertyElement?.textContent?.trim() || '';
    return value;
  };

  // Read individual address properties
  const addressData = {
    first_name: getMetafieldValue('_address_first_name') || '',
    last_name: getMetafieldValue('_address_last_name') || '',
    phone: getMetafieldValue('_address_phone') || '',
    address1: getMetafieldValue('_address_address1') || '',
    address2: getMetafieldValue('_address_address2') || '',
    company: getMetafieldValue('_address_company') || '',
    zip: getMetafieldValue('_address_zip') || '',
    cremation: getMetafieldValue('_address_cremation') || ''
  };

  const modal = document.getElementById('jsc-address-modal');

  if (!modal) {
    console.error('Address modal element not found in DOM');
    return;
  }

  try {
    modal.style.display = 'flex';
    modal.setAttribute('data-index', cartItemIndex);
    
    // Update modal title based on mode
    const modalTitle = modal.querySelector('.jsc-modal-title');
    if (modalTitle) {
      modalTitle.textContent = mode === 'Add' ? 'Add Recipient Address' : 'Edit Recipient Address';
    }
    
    renderAddressModalForm({
      first_name: addressData.first_name,
      last_name: addressData.last_name,
      phone: addressData.phone,
      address1: addressData.address1,
      address2: addressData.address2,
      company: addressData.company,
      zip: addressData.zip,
      cremation: addressData.cremation
    });
  } catch (error) {
    console.error('Error showing address modal:', error);
  }
}

renderAddressModalForm = (config) => {
  const container = document.getElementById('jsc-modal-address-container');
  if (!container) {
    console.error('Address modal container not found');
    return;
  }
  
  let formHTML = '<div class="jsc-gift-message">';
  
  formHTML += `
    <div class="form-field jsc-address-modal-name-fields">
      <div class="">
        <label for="first-name-modal" class="form-label">First Name:</label>
        <input 
          type="text" 
          id="first-name-modal" 
          name="first_name" 
          placeholder="Enter first name"
          value="${config.first_name || ''}"
          required
        >
      </div>
      <div class="">
        <label for="last-name-modal" class="form-label">Last Name:</label>
        <input 
          type="text" 
          id="last-name-modal" 
          name="last_name" 
          placeholder="Enter last name"
          value="${config.last_name || ''}"
          required
        >
      </div>
    </div>
  `;
  
  formHTML += `
    <div class="form-field">
      <label for="phone-modal" class="form-label">Recipient Mobile No:</label>
      <input 
        type="text" 
        id="phone-modal" 
        name="phone" 
        placeholder="Enter mobile number"
        value="${config.phone || ''}"
        required
      >
    </div>
  `;
  
  formHTML += `
    <div class="form-field">
      <label for="address1-modal" class="form-label">Address:</label>
      <input 
        type="text" 
        id="address1-modal" 
        name="address1" 
        placeholder="Enter address"
        value="${config.address1 || ''}"
        maxlength="40"
        required
      >
    </div>
  `;
  
  formHTML += `
    <div class="form-field">
      <label for="address2-modal" class="form-label">Apartment, suite, etc. (optional):</label>
      <input 
        type="text" 
        id="address2-modal" 
        name="address2" 
        placeholder="Enter apartment, suite, etc."
        value="${config.address2 || ''}"
        maxlength="40"
      >
    </div>
  `;

  formHTML += `
    <div class="form-field">
      <label for="company-modal" class="form-label">Company (optional):</label>
      <input 
        type="text" 
        id="company-modal" 
        name="company" 
        placeholder="Enter company"
        value="${config.company || ''}"
        maxlength="40"
      >
    </div>
  `;
  
  formHTML += `
    <div class="form-field">
      <label for="zip-modal" class="form-label">Postal Code:</label>
      <input 
        type="text" 
        id="zip-modal" 
        name="zip" 
        placeholder="Enter postal code"
        value="${config.zip || ''}"
        maxlength="10"
        required
      >
      <div id="jsc-hospital-postal-code-message" class="d-none" style="color: #d32f2f; margin-top: 10px; font-size: 14px;">
        Please note that night deliveries are not available to hospitals.
      </div>
    </div>
  `;

  formHTML += `
    <div class="form-field jsc-cremation-modal-field" style="${config.zip === '779393' ? '' : 'display: none;'}">
      <label for="cremation-modal" class="form-label">You have indicated Mandai Crematorium and Columbarium Complex as your delivery location. Kindly indicate the time of cremation:</label>
      <input 
        type="text" 
        id="cremation-modal" 
        name="cremation" 
        placeholder="If you are unsure, please leave &quot;NA&quot;."
        value="${config.cremation || ''}"
      >
    </div>
  `;
  
  formHTML += '</div>';
  
  container.innerHTML = formHTML;
  
  // Add event listener to check hospital postal codes
  const zipInput = container.querySelector('#zip-modal');
  if (zipInput) {
    const handlePostalCodeCheck = function() {
      const postalCode = this.value?.trim() || '';
      const messageElement = document.getElementById('jsc-hospital-postal-code-message');
      
      if (!messageElement) {
        return;
      }
      
      if (!postalCode) {
        messageElement.classList.add('d-none');
        return;
      }
      
      const hospitalPostalCodeList = FoxTheme?.settings?.multishippingHospitalPostalCodeList;
      if (!hospitalPostalCodeList) {
        messageElement.classList.add('d-none');
        return;
      }
      
      // Split the list by comma and trim each entry
      const hospitalCodes = hospitalPostalCodeList.split(',').map(code => code.trim()).filter(code => code.length > 0);
      
      // Check if postal code matches any hospital postal code (prefix matching)
      let isHospital = false;
      for (const hospitalCode of hospitalCodes) {
        if (postalCode.startsWith(hospitalCode)) {
          isHospital = true;
          break;
        }
      }
      
      // Show or hide message based on match
      if (isHospital) {
        messageElement.classList.remove('d-none');
      } else {
        messageElement.classList.add('d-none');
      }
    };
    
    zipInput.addEventListener('input', handlePostalCodeCheck);
    zipInput.addEventListener('change', handlePostalCodeCheck);
    // Check on initial load if there's a value
    if (config.zip) {
      handlePostalCodeCheck.call(zipInput);
    }

    // Toggle cremation field visibility based on postal code
    const handleCremationToggle = function() {
      const cremationField = container.querySelector('.jsc-cremation-modal-field');
      if (!cremationField) return;
      const zip = this.value?.trim() || '';
      if (zip === '779393') {
        cremationField.style.display = '';
      } else {
        cremationField.style.display = 'none';
        const cremationInput = cremationField.querySelector('#cremation-modal');
        if (cremationInput) cremationInput.value = '';
      }
    };
    zipInput.addEventListener('input', handleCremationToggle);
    zipInput.addEventListener('change', handleCremationToggle);
  }
  
  // Filter out '~' character from all address modal input fields
  const addressModalFields = [
    'first-name-modal',
    'last-name-modal',
    'phone-modal',
    'address1-modal',
    'address2-modal',
    'company-modal',
    'zip-modal',
    'cremation-modal'
  ];
  
  addressModalFields.forEach(function(fieldId) {
    const field = container.querySelector(`#${fieldId}`);
    if (field) {
      field.addEventListener('input', function() {
        const filteredValue = this.value.replace(/~/g, '');
        if (this.value !== filteredValue) {
          this.value = filteredValue;
        }
      });
    }
  });
}

closeAddressModal = () => {
  document.getElementById('jsc-address-modal').style.display = 'none';
}

validatePostalCode = (postalCode) => {
  if (!postalCode || !postalCode.trim()) {
    return { valid: false, message: 'Postal code is required' };
  }
  
  // Ensure postal code input does not contain asterisk
  if (postalCode.includes('*')) {
    return { valid: false, message: 'Postal code is not valid' };
  }
  
  const postalCodeList = FoxTheme?.settings?.multishippingValidatedPostalCodeList;
  const hospitalPostalCodeList = FoxTheme?.settings?.multishippingHospitalPostalCodeList;
  
  // Combine both lists - hospital codes are also considered validated
  let allValidCodes = [];
  
  if (postalCodeList) {
    const validCodes = postalCodeList.split(',').map(code => code.trim()).filter(code => code.length > 0);
    allValidCodes = allValidCodes.concat(validCodes);
  }
  
  if (hospitalPostalCodeList) {
    const hospitalCodes = hospitalPostalCodeList.split(',').map(code => code.trim()).filter(code => code.length > 0);
    allValidCodes = allValidCodes.concat(hospitalCodes);
  }
  
  // If no validation lists are available, allow any postal code
  if (allValidCodes.length === 0) {
    return { valid: true };
  }
  
  // Check if postal code matches any entry from either list (prefix matching)
  for (const validCode of allValidCodes) {
    if (postalCode.startsWith(validCode)) {
      return { valid: true };
    }
  }
  
  return { valid: false, message: 'Postal code is not valid' };
}

saveAddress = async () => {
  const modal = document.getElementById('jsc-address-modal');
  const cartItemIndex = modal.getAttribute('data-index');
  
  if (!cartItemIndex) {
    alert('Error: Cannot save address. Please try again.');
    return;
  }
  
  // Get form data
  const form = document.getElementById('jsc-address-form');
  const formData = new FormData(form);
  
  // Validate required fields
  const firstName = formData.get('first_name')?.trim() || '';
  const lastName = formData.get('last_name')?.trim() || '';
  const phoneRaw = formData.get('phone')?.trim() || '';
  const address1 = formData.get('address1')?.trim() || '';
  const postalCode = formData.get('zip')?.trim() || '';
  
  // Clean phone number: remove "+65" and all spaces, keep only digits
  const phone = phoneRaw.replace(/\+65/gi, '').replace(/\s+/g, '').replace(/[^0-9]/g, '');
  
  let hasValidationError = false;
  
  // Remove any existing error messages
  const existingErrors = form.querySelectorAll('.jsc-address-validation-error');
  existingErrors.forEach(error => error.remove());
  
  // Validate First Name and Last Name (combined validation for name fields container)
  if (!firstName || !lastName) {
    const firstNameField = form.querySelector('#first-name-modal');
    if (firstNameField) {
      const nameFieldsContainer = firstNameField.closest('.jsc-address-modal-name-fields');
      if (nameFieldsContainer) {
        let errorMessage = '';
        if (!firstName && !lastName) {
          errorMessage = 'First Name and Last Name are required';
        } else if (!firstName) {
          errorMessage = 'First Name is required';
        } else {
          errorMessage = 'Last Name is required';
        }
        
        const errorElement = document.createElement('div');
        errorElement.className = 'jsc-address-validation-error';
        errorElement.style.cssText = 'color: #d32f2f; margin-top: 15px; padding: 10px; background-color: #ffebee; border-radius: 4px; font-size: 14px;';
        errorElement.textContent = errorMessage;
        nameFieldsContainer.insertAdjacentElement('afterend', errorElement);
        
        setTimeout(function() {
          if (errorElement && errorElement.parentNode) {
            errorElement.style.transition = 'opacity 0.3s';
            errorElement.style.opacity = '0';
            setTimeout(function() {
              errorElement.remove();
            }, 300);
          }
        }, 5000);
        hasValidationError = true;
      }
    }
  }
  
  // Validate Phone
  if (!phone) {
    const phoneField = form.querySelector('#phone-modal');
    if (phoneField) {
      const phoneFieldContainer = phoneField.closest('.form-field');
      if (phoneFieldContainer) {
        const errorElement = document.createElement('div');
        errorElement.className = 'jsc-address-validation-error';
        errorElement.style.cssText = 'color: #d32f2f; margin-top: 15px; padding: 10px; background-color: #ffebee; border-radius: 4px; font-size: 14px;';
        errorElement.textContent = 'Recipient Mobile No is required';
        phoneFieldContainer.insertAdjacentElement('afterend', errorElement);
        
        setTimeout(function() {
          if (errorElement && errorElement.parentNode) {
            errorElement.style.transition = 'opacity 0.3s';
            errorElement.style.opacity = '0';
            setTimeout(function() {
              errorElement.remove();
            }, 300);
          }
        }, 5000);
        hasValidationError = true;
      }
    }
  } else {
    // Validate phone number format: accepts "+65 XXXX XXXX" or "XXXX XXXX" or "XXXXXXXX"
    // After cleaning (removing +65 and spaces), must be exactly 8 digits
    if (phone.length !== 8 || !/^[0-9]{8}$/.test(phone)) {
      const phoneField = form.querySelector('#phone-modal');
      if (phoneField) {
        const phoneFieldContainer = phoneField.closest('.form-field');
        if (phoneFieldContainer) {
          const errorElement = document.createElement('div');
          errorElement.className = 'jsc-address-validation-error';
          errorElement.style.cssText = 'color: #d32f2f; margin-top: 15px; padding: 10px; background-color: #ffebee; border-radius: 4px; font-size: 14px;';
          errorElement.textContent = 'Recipient Mobile No must be exactly 8 digits (+65 XXXX XXXX)';
          phoneFieldContainer.insertAdjacentElement('afterend', errorElement);
          
          setTimeout(function() {
            if (errorElement && errorElement.parentNode) {
              errorElement.style.transition = 'opacity 0.3s';
              errorElement.style.opacity = '0';
              setTimeout(function() {
                errorElement.remove();
              }, 300);
            }
          }, 5000);
          hasValidationError = true;
        }
      }
    }
  }
  
  // Validate Address
  if (!address1) {
    const address1Field = form.querySelector('#address1-modal');
    if (address1Field) {
      const addressFieldContainer = address1Field.closest('.form-field');
      if (addressFieldContainer) {
        const errorElement = document.createElement('div');
        errorElement.className = 'jsc-address-validation-error';
        errorElement.style.cssText = 'color: #d32f2f; margin-top: 15px; padding: 10px; background-color: #ffebee; border-radius: 4px; font-size: 14px;';
        errorElement.textContent = 'Address is required';
        addressFieldContainer.insertAdjacentElement('afterend', errorElement);
        
        setTimeout(function() {
          if (errorElement && errorElement.parentNode) {
            errorElement.style.transition = 'opacity 0.3s';
            errorElement.style.opacity = '0';
            setTimeout(function() {
              errorElement.remove();
            }, 300);
          }
        }, 5000);
        hasValidationError = true;
      }
    }
  }
  
  // Validate Postal Code
  const postalCodeValidation = validatePostalCode(postalCode);
  if (!postalCodeValidation.valid) {
    const zipField = form.querySelector('#zip-modal');
    if (zipField) {
      const zipFieldContainer = zipField.closest('.form-field');
      if (zipFieldContainer) {
        const errorElement = document.createElement('div');
        errorElement.className = 'jsc-address-validation-error';
        errorElement.style.cssText = 'color: #d32f2f; margin-top: 15px; padding: 10px; background-color: #ffebee; border-radius: 4px; font-size: 14px;';
        errorElement.textContent = postalCodeValidation.message || 'Postal Code is required';
        zipFieldContainer.insertAdjacentElement('afterend', errorElement);
        
        setTimeout(function() {
          if (errorElement && errorElement.parentNode) {
            errorElement.style.transition = 'opacity 0.3s';
            errorElement.style.opacity = '0';
            setTimeout(function() {
              errorElement.remove();
            }, 300);
          }
        }, 5000);
        hasValidationError = true;
      }
    }
  }
  
  if (hasValidationError) {
    return;
  }
  
  closeAddressModal();
  cartItemStartLoading(cartItemIndex);
  
  // Get quantity from DOM
  const mainCartElement = document.querySelector('main-cart');
  const sectionId = mainCartElement ? FoxTheme.utils.getSectionId(mainCartElement) : null;
  const quantityInput = document.getElementById(`Quantity-${sectionId}-${cartItemIndex}`);
  const quantity = parseInt(quantityInput.value) || 1;
  
  // Get remaining form values (firstName, lastName, phone, address1, postalCode already declared above)
  const address2 = formData.get('address2') || '';
  const company = formData.get('company') || '';
  const cremation = formData.get('cremation')?.trim() || '';
  
  // Get cart item row from DOM to preserve properties
  const mainCart = sectionId ? document.querySelector(`#MainCart-${sectionId}`) : null;
  const cartItemRow = mainCart ? mainCart.querySelector(`.cart-item[data-index="${cartItemIndex}"]`) : null;
  
  // Build updated properties - preserve all existing properties from DOM (including _Binding_ID which is now rendered)
  const updatedProperties = {};
  
  if (cartItemRow) {
    const propertyElements = cartItemRow.querySelectorAll('[data-property]');
    propertyElements.forEach(propEl => {
      const propertyName = propEl.getAttribute('data-property');
      const propertyValue = propEl.querySelector('dd')?.textContent?.trim() || '';
      
      // Skip all _address_* properties and Address - we'll set them separately
      if (!propertyName.startsWith('_address_') && propertyName !== 'Recipient Address') {
        updatedProperties[propertyName] = propertyValue;
      }
    });
  } else {
    // Fallback to API if DOM approach fails (cartItemRow not found)
    // Note: This requires async, but we'll handle it with a promise
    console.warn('Cart item row not found in DOM, properties may not be fully preserved');
  }
    
  // Now update with address properties
  // Add individual address properties
  updatedProperties['_address_first_name'] = firstName;
  updatedProperties['_address_last_name'] = lastName;
  updatedProperties['_address_phone'] = phone;
  updatedProperties['_address_address1'] = address1;
  updatedProperties['_address_address2'] = address2;
  updatedProperties['_address_company'] = company;
  updatedProperties['_address_zip'] = postalCode;
  updatedProperties['_address_cremation'] = cremation;
  updatedProperties['_address_name'] = `${firstName} ${lastName}`.trim();
  updatedProperties['_address_city'] = 'Singapore';
  updatedProperties['_address_country'] = 'Singapore';
  updatedProperties['_address_country_code'] = 'SG';
  
  // Build combined Address property
  const addressParts = [];
  if (firstName || lastName) {
    addressParts.push(`${firstName} ${lastName}`.trim());
  }
  if (phone) {
    addressParts.push(`+65 ${phone}`);
  }
  if (company) {
    addressParts.push(company);
  }
  if (address1) {
    addressParts.push(address1);
  }
  if (address2) {
    addressParts.push(address2);
  }
  if (postalCode) {
    addressParts.push(`Singapore ${postalCode}`);
  }
  updatedProperties['Recipient Address'] = addressParts.join(', ');
  
  CartJS.updateItem(cartItemIndex, quantity, updatedProperties)
    .then(data => {
      console.log('Cart updated successfully.');
      return refreshMainCartSection();
    })
    .then(() => {
      cartItemCompleteLoading(cartItemIndex);
      checkHospitalCodeExists();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      cartItemCompleteLoading(cartItemIndex);
    });
}

removeAddress = () => {
  const modal = document.getElementById('jsc-address-modal');
  const cartItemIndex = modal.getAttribute('data-index');
  
  if (!cartItemIndex) {
    alert('Error: Cannot remove address. Please try again.');
    return;
  }
  
  closeAddressModal();
  cartItemStartLoading(cartItemIndex);
  
  // Get quantity from DOM
  const mainCartElement = document.querySelector('main-cart');
  const sectionId = mainCartElement ? FoxTheme.utils.getSectionId(mainCartElement) : null;
  const quantityInput = sectionId ? document.getElementById(`Quantity-${sectionId}-${cartItemIndex}`) : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  
  // Get cart item row from DOM
  const mainCart = sectionId ? document.querySelector(`#MainCart-${sectionId}`) : null;
  const cartItemRow = mainCart ? mainCart.querySelector(`.cart-item[data-index="${cartItemIndex}"]`) : null;
  
  if (!cartItemRow) {
    console.error('Cart item row not found for index:', cartItemIndex);
    cartItemCompleteLoading(cartItemIndex);
    return;
  }
  
  // Get all properties from DOM (from data-property elements)
  const updatedProperties = {};
  const propertyElements = cartItemRow.querySelectorAll('[data-property]');
  
  propertyElements.forEach(propEl => {
    const propertyName = propEl.getAttribute('data-property');
    const propertyValue = propEl.querySelector('dd')?.textContent?.trim() || '';
    
    // Skip all _address_* properties - we'll remove them
    if (!propertyName.startsWith('_address_')) {
      updatedProperties[propertyName] = propertyValue;
    }
  });
  
  // Explicitly set all _address_* properties to empty string to remove them
  updatedProperties['_address_first_name'] = '';
  updatedProperties['_address_last_name'] = '';
  updatedProperties['_address_phone'] = '';
  updatedProperties['_address_address1'] = '';
  updatedProperties['_address_address2'] = '';
  updatedProperties['_address_company'] = '';
  updatedProperties['_address_zip'] = '';
  updatedProperties['_address_cremation'] = '';
  updatedProperties['_address_name'] = '';
  updatedProperties['_address_city'] = '';
  updatedProperties['_address_country'] = '';
  updatedProperties['_address_country_code'] = '';
  updatedProperties['Recipient Address'] = ''; // Also remove the combined Address property
  
  CartJS.updateItem(cartItemIndex, quantity, updatedProperties)
    .then(data => {
      console.log('Cart updated successfully.');
      return refreshMainCartSection();
    })
    .then(() => {
      cartItemCompleteLoading(cartItemIndex);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      cartItemCompleteLoading(cartItemIndex);
    });
}
// end: Address Modal Functions

//start: Multishipping attribute check
checkAndSetMultishippingAttribute = async () => {
  const checkbox = document.querySelector('.jsc-cart-multishipping-checkbox');
  const cartContainer = document.querySelector('.cart');
  
  if (!cartContainer) {
    return;
  }
  
  // Check for international delivery items and remove multishipping if found
  try {
    const cartResponse = await fetch(`${FoxTheme.routes.cart_url}.js`, { ...FoxTheme.utils.fetchConfig() });
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart');
    }
    const cartData = await cartResponse.json();
    
    // Check if any item has international delivery tag
    const hasInternationalDelivery = cartData.items.some(item => {
      if (item.properties && (item.properties._Is_Addon === 'true' || item.properties._is_gwp === 'true')) {
        return false;
      }
      if (item.product && item.product.tags) {
        return item.product.tags.some(tag => 
          tag.toLowerCase().includes('international delivery')
        );
      }
      return false;
    });
    
    // If international delivery item exists, remove multishipping attribute
    if (hasInternationalDelivery) {
      cartContainer.setAttribute('data-multishipping-checked', 'false');
      
      const attributes = { ...cartData.attributes };
      attributes['Requires Multishipping'] = '';
      
      const requestBody = JSON.stringify({
        attributes: attributes
      });
      
      await fetch(`${FoxTheme.routes.cart_update_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        body: requestBody
      });
      
      return; // Exit early if international delivery items found
    }
  } catch (error) {
    console.error('Error checking international delivery items:', error);
  }
  
  // If checkbox doesn't exist, check if it should exist first before removing multishipping
  if (!checkbox) {
    try {
      // Fetch current cart to check main item count
      const cartResponse = await fetch(`${FoxTheme.routes.cart_url}.js`, { ...FoxTheme.utils.fetchConfig() });
      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart');
      }
      const cartData = await cartResponse.json();
      
      // Count main items (exclude addons, GWP, and gift cards) - matching Liquid snippet logic
      let mainItemCount = 0;
      for (const item of cartData.items) {
        const isAddon = item.properties && item.properties._Is_Addon === 'true';
        const isGwp = item.properties && item.properties._is_gwp === 'true';
        const isGiftCard = item.product && item.product.gift_card === true;
        
        // Match the Liquid logic: exclude addons, GWP, and gift cards
        if (!isAddon && !isGwp && !isGiftCard) {
          mainItemCount++;
        }
      }
      
      // Only remove multishipping if we shouldn't have it (main_item_count <= 1)
      // If main_item_count > 1, checkbox should exist but might not be rendered yet
      if (mainItemCount <= 1) {
        cartContainer.setAttribute('data-multishipping-checked', 'false');
        
        // Get existing attributes, preserving all other properties
        const attributes = { ...cartData.attributes };
        
        // Remove the "Requires Multishipping" attribute
        attributes['Requires Multishipping'] = '';
        
        // Update cart with new attributes (no sections update to avoid refresh)
        const requestBody = JSON.stringify({
          attributes: attributes
        });
        
        await fetch(`${FoxTheme.routes.cart_update_url}`, {
          ...FoxTheme.utils.fetchConfig(),
          body: requestBody
        });
      }
      // If mainItemCount > 1, don't remove multishipping - checkbox will be rendered soon
    } catch (error) {
      console.error('Error updating cart attributes:', error);
    }
  }
}
// Function to check if only 1 main item remains and remove multishipping if so
checkAndRemoveMultishippingIfSingleItem = async () => {
  const cartContainer = document.querySelector('.cart');
  
  if (!cartContainer) {
    return;
  }
  
  try {
    const cartResponse = await fetch(`${FoxTheme.routes.cart_url}.js`, { ...FoxTheme.utils.fetchConfig() });
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart');
    }
    const cartData = await cartResponse.json();
    
    if (!cartData.items || cartData.items.length === 0) {
      return; // No items in cart
    }
    
    // Count main items (exclude addons and gift cards) - matching Liquid snippet logic
    let mainItemCount = 0;
    for (const item of cartData.items) {
      const isAddon = item.properties && item.properties._Is_Addon === 'true';
      const isGwp = item.properties && item.properties._is_gwp === 'true';
      const isGiftCard = item.product && item.product.gift_card === true;
      
      // Match the Liquid logic: exclude addons, GWP, and gift cards
      if (!isAddon && !isGwp && !isGiftCard) {
        mainItemCount++;
      }
    }
    
    // If only 1 main item, remove multishipping
    if (mainItemCount <= 1) {
      cartContainer.setAttribute('data-multishipping-checked', 'false');
      
      // Update cart attributes via API
      const attributes = { ...cartData.attributes };
      attributes['Requires Multishipping'] = '';
      
      const requestBody = JSON.stringify({
        attributes: attributes
      });
      
      await fetch(`${FoxTheme.routes.cart_update_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        body: requestBody
      });
      
      // Update checkbox if it exists
      const checkbox = document.querySelector('.jsc-cart-multishipping-checkbox input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = false;
      }
    }
  } catch (error) {
    console.error('Error checking single item for multishipping removal:', error);
  }
}
//end: Multishipping attribute check

// Nested delivery charge. Same variant under every recipient, so each line
// needs its own properties or Shopify merges them and increments quantity.
function getCartFeeProducts() {
  return window.FoxTheme?.settings?.cartFeeProducts || {};
}

function getMultishipShippingVariantId() {
  const id = Number(getCartFeeProducts().shippingVariantId);
  return id || null;
}

function getCartFeeProductHandles() {
  const handles = new Set();
  const configured = getCartFeeProducts().handles;
  if (Array.isArray(configured)) {
    configured.forEach((handle) => {
      if (handle) handles.add(handle);
    });
  }

  getSurchargeSettings().forEach((config) => {
    if (config && config.product) handles.add(config.product);
  });
  getCbdSurchargeSettings().forEach((config) => {
    if (config && config.product) handles.add(config.product);
  });

  const shippingHandle = getCartFeeProducts().shippingHandle;
  if (shippingHandle) handles.add(shippingHandle);

  return handles;
}

function setCartFeeLoader(active, message) {
  const loader = document.getElementById('jsc-cart-fee-loader');
  if (loader) {
    loader.hidden = !active;
    loader.setAttribute('aria-busy', active ? 'true' : 'false');
    if (message) {
      const text = loader.querySelector('.jsc-cart-fee-loader__text');
      if (text) text.textContent = message;
    }
  }
  document.documentElement.classList.toggle('jsc-cart-fee-loading', active);

  document.querySelectorAll('header, footer, cart-drawer, .cart .section__container').forEach((el) => {
    if (active) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  });
}

async function changeCartLine(line, quantity, sections) {
  const payload = { line, quantity };
  if (sections) {
    payload.sections = sections;
  }

  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(`Failed to update cart line ${line}`);
  }

  return response.json();
}

async function removeCartLinesByLineNumber(lineNumbers, sections) {
  const sorted = [...lineNumbers].sort((a, b) => b - a);
  let cart = null;

  for (let i = 0; i < sorted.length; i++) {
    const isLast = i === sorted.length - 1;
    cart = await changeCartLine(sorted[i], 0, isLast ? sections : null);
  }

  return cart;
}

// Nested shipping is one delivery charge per parent. Quantity above 1 is an overcharge.
async function normalizeNestedShippingQuantity(shippingVariantId, expectedCount) {
  const cartResponse = await fetch('/cart.js');
  if (!cartResponse.ok) {
    throw new Error('Failed to fetch cart');
  }
  const cart = await cartResponse.json();
  const groups = new Map();

  cart.items.forEach((item, index) => {
    if (Number(item.variant_id) !== Number(shippingVariantId)) {
      return;
    }

    const parentKey = (item.parent_relationship && item.parent_relationship.parent_key)
      || (item.properties && item.properties._ship_for)
      || `unscoped-${index}`;

    if (!groups.has(parentKey)) {
      groups.set(parentKey, []);
    }
    groups.get(parentKey).push({ line: index + 1, quantity: item.quantity });
  });

  const changes = [];
  groups.forEach((entries) => {
    const [keep, ...extras] = entries;
    if (keep.quantity !== 1) {
      changes.push({ line: keep.line, quantity: 1 });
    }
    extras.forEach((extra) => {
      changes.push({ line: extra.line, quantity: 0 });
    });
  });

  changes.sort((a, b) => b.line - a.line);
  for (const change of changes) {
    await changeCartLine(change.line, change.quantity);
  }

  const verifyResponse = await fetch('/cart.js');
  if (!verifyResponse.ok) {
    throw new Error('Failed to fetch cart');
  }
  const verify = await verifyResponse.json();
  const shippingLines = verify.items.filter((item) => Number(item.variant_id) === Number(shippingVariantId));
  if (shippingLines.length !== expectedCount || shippingLines.some((item) => item.quantity !== 1)) {
    throw new Error('Nested shipping quantity could not be kept at 1');
  }
}

//start: Remove multishipping variant and surcharge products on page load
async function removeShippingProductsAndSurcharge() {
  const shippingProductVariantId = getMultishipShippingVariantId();
  const shippingHandle = getCartFeeProducts().shippingHandle;
  
  try {
    // Fetch current cart data from API
    const cartResponse = await fetch(`${FoxTheme.routes.cart_url}.js`, { ...FoxTheme.utils.fetchConfig() });
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart');
    }
    const cartData = await cartResponse.json();
    
    if (!cartData.items || cartData.items.length === 0) {
      return; // No items in cart
    }
    
    const surchargeProductHandles = getCartFeeProductHandles();
    
    // Find items to remove:
    // 1. Items with the multishipping variant ID
    // 2. Items matching surcharge product handles
    const lineNumbersToRemove = [];
    cartData.items.forEach((item, index) => {
      const productHandle = (item.product && item.product.handle) || item.handle;
      const isShipping = Number(item.variant_id) === Number(shippingProductVariantId)
        || (shippingHandle && productHandle === shippingHandle);
      if (isShipping || (productHandle && surchargeProductHandles.has(productHandle))) {
        lineNumbersToRemove.push(index + 1);
      }
    });
    
    // Nested lines share a line key when properties match, so update.js cannot
    // target one child. change.js `line` is the supported way to remove them.
    if (lineNumbersToRemove.length > 0) {
      setCartFeeLoader(true, 'Updating cart');
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const parsedState = await removeCartLinesByLineNumber(lineNumbersToRemove, sectionsToBundle);
      if (parsedState) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
        if (window.location.pathname.includes('/cart')) {
          await refreshMainCartSection();
        }
      }
    }
  } catch (error) {
    console.error('Shipping and Surcharge Check Error:', error);
  } finally {
    setCartFeeLoader(false);
  }
}
//end: Remove multishipping variant and surcharge products on page load

//start: Multishipping checkout
let isProcessingCheckout = false;

/** Same DOM checks as Zapiet multiship early-exit: require a selected slot and no loading spinner. */
function isZapietDeliveryReady() {
  const storePickupApp = document.querySelector('#storePickupApp');
  if (!storePickupApp) return true;
  const hasSelectedTime = storePickupApp.querySelector(
    '.ZapietStack-Item .Zapiet-Select__Option.Zapiet-Select__Option--selected.picker__list-item'
  );
  const zapietIsLoading = storePickupApp.querySelector('.spinnerContainer');
  return !!(hasSelectedTime && !zapietIsLoading);
}

// Multishipping checkout function (CSS handles button visibility)
customCheckout = function(event) {
  const checkoutButton = event?.target?.closest('.jsc-multiship-checkout-button') || document.querySelector('.jsc-multiship-checkout-button');
  const cartContainer = document.querySelector('.cart');
  
  if (!checkoutButton || !cartContainer) {
    console.error('Multiship checkout button or cart container not found');
    return;
  }
  
  // Prevent multiple simultaneous checkout attempts
  if (isProcessingCheckout) {
    return false;
  }
  
  // Check if multishipping is enabled
  const isMultishipping = cartContainer.getAttribute('data-multishipping-checked') === 'true';
  
  // If multishipping is not checked, process non-multiship surcharge then submit
  if (!isMultishipping) {
    if (!isZapietDeliveryReady()) {
      return;
    }
    // Process delivery surcharge before checkout
    processNonMultishipSurcharge().then(success => {
      if (success) {
        const cartForm = document.getElementById('cart');
        if (cartForm) {
          cartForm.submit();
        }
      } else {
        isProcessingCheckout = false;
        checkoutButton.classList.remove('btn--loading');
        checkoutButton.disabled = false;
      }
    });
    return;
  }
  
  // Multishipping checkout flow
  isProcessingCheckout = true;
  
  // Check if Zapiet time is not selected - if so, return early
  if (!isZapietDeliveryReady()) {
    isProcessingCheckout = false;
    return;
  }
  
  // Count main items (exclude addons which have jsc-cart-item-addon class)
  const allCartItems = document.querySelectorAll('.cart-item[data-key]');
  const mainItems = Array.from(allCartItems).filter(item => !item.classList.contains('jsc-cart-item-addon'));
  
  const uniqueAddresses = new Set();
  let itemsWithoutAddress = 0;

  // Count unique addresses using Address property and check all items have addresses
  for (const cartItem of mainItems) {
    const addressProperty = cartItem.querySelector('[data-property="Recipient Address"]');
    if (addressProperty) {
      const addressValue = addressProperty.querySelector('dd')?.textContent?.trim() || '';
      if (addressValue) {
        uniqueAddresses.add(addressValue);
      } else {
        itemsWithoutAddress++;
      }
    } else {
      itemsWithoutAddress++;
    }
  }

  const uniqueAddressCount = uniqueAddresses.size;

  // Ensure all items have addresses
  if (itemsWithoutAddress > 0 || uniqueAddressCount === 0) {
    isProcessingCheckout = false;
    alert('Please add addresses for all items before checkout.');
    return;
  }

  // Show loading state
  checkoutButton.classList.add('btn--loading');
  checkoutButton.disabled = true;
  setCartFeeLoader(true, 'Finalizing...');

  // Get first recipient address for prefilling checkout
  function getFirstRecipientAddress() {
    for (const cartItem of mainItems) {
      const getAddressValue = (propertyName) => {
        const propertyElement = cartItem.querySelector(`[data-property="${propertyName}"]`);
        if (propertyElement) {
          const valueElement = propertyElement.querySelector('dd');
          return valueElement ? valueElement.textContent.trim() : '';
        }
        return '';
      };

      const address1 = getAddressValue('_address_address1');
      if (address1) {
        // Found first item with address, return all address fields
        return {
          first_name: getAddressValue('_address_first_name'),
          last_name: getAddressValue('_address_last_name'),
          phone: getAddressValue('_address_phone'),
          address1: address1,
          address2: getAddressValue('_address_address2'),
          company: getAddressValue('_address_company'),
          city: getAddressValue('_address_city'),
          province: getAddressValue('_address_province') || getAddressValue('_address_state'),
          country: getAddressValue('_address_country'),
          zip: getAddressValue('_address_zip')
        };
      }
    }
    return null;
  }

  // Build checkout URL with address parameters
  function buildCheckoutUrl(address) {
    if (!address) {
      return '/checkout';
    }

    const params = new URLSearchParams();
    
    if (address.first_name) params.append('checkout[shipping_address][first_name]', address.first_name);
    if (address.last_name) params.append('checkout[shipping_address][last_name]', address.last_name);
    if (address.phone) {
      const phoneStripped = address.phone.replace(/\s+/g, '');
      params.append('checkout[shipping_address][phone]', `+65${phoneStripped}`);
    }
    if (address.address1) params.append('checkout[shipping_address][address1]', address.address1);
    if (address.address2) params.append('checkout[shipping_address][address2]', address.address2);
    if (address.company) params.append('checkout[shipping_address][company]', address.company);
    if (address.city) params.append('checkout[shipping_address][city]', address.city);
    if (address.province) params.append('checkout[shipping_address][province]', address.province);
    if (address.country) params.append('checkout[shipping_address][country]', address.country);
    if (address.zip) params.append('checkout[shipping_address][zip]', address.zip);

    const queryString = params.toString();
    return queryString ? `/checkout?${queryString}` : '/checkout';
  }

  // Process multiship shipping and surcharge together
  processMultishipShippingAndSurcharge().then(success => {
    if (!success) {
      isProcessingCheckout = false;
      checkoutButton.classList.remove('btn--loading');
      checkoutButton.disabled = false;
      setCartFeeLoader(false);
      return;
    }
    
    // Get first recipient address and build checkout URL
    const firstAddress = getFirstRecipientAddress();
    const checkoutUrl = buildCheckoutUrl(firstAddress);
    
    // Successfully added - redirect to checkout with prefilled address
    isProcessingCheckout = false;
    window.location.href = checkoutUrl;
  })
  .catch(error => {
    console.error('Error in multishipping checkout:', error);
    isProcessingCheckout = false;
    checkoutButton.classList.remove('btn--loading');
    checkoutButton.disabled = false;
    setCartFeeLoader(false);
    
    alert("There's an error while checkout. Please try again.");
  });
}

// Check if multishipping is enabled and addresses are missing
function checkMultishippingAddresses() {
  const cartContainer = document.querySelector('.cart');
  if (!cartContainer) {
    return;
  }
  
  // 1. Check if data-multishipping-checked is true
  const isMultishipping = cartContainer.getAttribute('data-multishipping-checked') === 'true';
  if (!isMultishipping) {
    return;
  }
  
  // 2. Check if there are any "Recipient Address" hidden fields
  const addressFields = document.querySelectorAll('[data-property="Recipient Address"]');
  
  // 3. If no Address fields found, show alert
  if (addressFields.length === 0) {
    alert('Please add addresses for all items before checkout.');
  }
}

// Initialize on page load - ensure function is available globally
function initializeCustomCheckout() {
  // Function is already defined globally, but we can verify multiship button exists
  const multishipButton = document.querySelector('.jsc-multiship-checkout-button');
  if (multishipButton && !multishipButton.hasAttribute('onclick')) {
    // If onclick wasn't set in HTML, attach it via JavaScript as fallback
    multishipButton.addEventListener('click', customCheckout);
  }
  
  // Setup listener for regular checkout button
  const checkoutButton = document.querySelector('.jsc-checkout-button');
  if (checkoutButton) {
    checkoutButton.addEventListener('click', function(e) {
      // Check multishipping addresses first
      checkMultishippingAddresses();
      
      // Intercept form submission for non-multiship checkout
      const cartContainer = document.querySelector('.cart');
      const isMultishipping = cartContainer && cartContainer.getAttribute('data-multishipping-checked') === 'true';
      
      if (!isMultishipping) {
        e.preventDefault();
        e.stopPropagation();

        if (!isZapietDeliveryReady()) {
          return;
        }
        
        // Process surcharge before checkout
        const button = e.target.closest('.jsc-checkout-button');
        if (button) {
          button.classList.add('btn--loading');
          button.disabled = true;
        }
        
        processNonMultishipSurcharge().then(success => {
          if (success) {
            const cartForm = document.getElementById('cart');
            if (cartForm) {
              cartForm.submit();
            }
          } else {
            if (button) {
              button.classList.remove('btn--loading');
              button.disabled = false;
            }
          }
        });
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCustomCheckout);
} else {
  initializeCustomCheckout();
}

//start: Delivery Surcharge Logic
/**
 * Parse delivery date string to Date object(s)
 * @param {string} deliveryDate - Format: "2026/02/09" (10 chars) or "2026/02/09 - 2026/02/10" (23 chars)
 * @returns {Array<Date>} Array of Date objects (single date or date range)
 */
function parseDeliveryDate(deliveryDate) {
  if (!deliveryDate || typeof deliveryDate !== 'string') {
    return [];
  }
  
  const trimmed = deliveryDate.trim();
  
  // Single date format: "2026/02/09" (10 characters - YYYY/MM/DD)
  if (trimmed.length === 10 && trimmed.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
    // Convert YYYY/MM/DD to YYYY-MM-DD for Date parsing
    const dateStr = trimmed.replace(/\//g, '-');
    const date = new Date(dateStr);
    if (!isNaN(date.getTime())) {
      return [date];
    }
  }
  
  // Date range format: "2026/02/09 - 2026/02/10" (23 characters)
  if (trimmed.length === 23) {
    const parts = trimmed.split(' - ');
    if (parts.length === 2) {
      const startDateStr = parts[0].trim();
      const endDateStr = parts[1].trim();
      
      // Validate both parts are in correct format (YYYY/MM/DD)
      if (startDateStr.match(/^\d{4}\/\d{2}\/\d{2}$/) && endDateStr.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
        const startDate = new Date(startDateStr.replace(/\//g, '-'));
        const endDate = new Date(endDateStr.replace(/\//g, '-'));
        
        if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
          // Generate all dates in the range
          const dates = [];
          const currentDate = new Date(startDate);
          while (currentDate <= endDate) {
            dates.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
          }
          return dates;
        }
      }
    }
  }
  
  return [];
}

/**
 * Check if a date falls within a date range
 * @param {Date} date - Date to check
 * @param {string} startDateStr - Start date string in YYYY-MM-DD format
 * @param {string} endDateStr - End date string in YYYY-MM-DD format
 * @returns {boolean}
 */
function isDateInRange(date, startDateStr, endDateStr) {
  if (!date || !startDateStr || !endDateStr) {
    return false;
  }
  
  // Convert YYYY/MM/DD to YYYY-MM-DD for Date parsing
  const normalizedStartDateStr = startDateStr.replace(/\//g, '-');
  const normalizedEndDateStr = endDateStr.replace(/\//g, '-');
  
  const startDate = new Date(normalizedStartDateStr);
  const endDate = new Date(normalizedEndDateStr);
  
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    return false;
  }
  
  // Set time to midnight for accurate comparison
  const checkDate = new Date(date);
  checkDate.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  
  return checkDate >= startDate && checkDate <= endDate;
}

/**
 * Check if any date in an array falls within a date range
 * @param {Array<Date>} dates - Array of dates to check
 * @param {string} startDateStr - Start date string in YYYY/MM/DD or YYYY-MM-DD format
 * @param {string} endDateStr - End date string in YYYY/MM/DD or YYYY-MM-DD format
 * @returns {boolean}
 */
function hasDateInRange(dates, startDateStr, endDateStr) {
  return dates.some(date => isDateInRange(date, startDateStr, endDateStr));
}

/**
 * Get surcharge settings from theme settings
 * @returns {Array} Array of surcharge configuration objects
 */
function getSurchargeSettings() {
  // Access theme settings from Liquid (injected via script tag)
  const settingsScript = document.querySelector('script[data-surcharge-settings]');
  if (settingsScript) {
    try {
      const content = settingsScript.textContent || settingsScript.innerHTML;
      if (content) {
        const parsed = JSON.parse(content.trim());
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch (e) {
      console.error('Error parsing surcharge settings:', e);
    }
  }
  
  // Fallback: try to get from window object if set elsewhere
  if (window.themeSettings && window.themeSettings.surcharge) {
    return window.themeSettings.surcharge;
  }
  
  return [];
}

/**
 * Get CBD surcharge settings from theme settings (script[data-cbd-surcharge-settings])
 * @returns {Array} Array of CBD surcharge configuration objects { enable, postal_codes, product }
 */
function getCbdSurchargeSettings() {
  const settingsScript = document.querySelector('script[data-cbd-surcharge-settings]');
  if (settingsScript) {
    try {
      const content = settingsScript.textContent || settingsScript.innerHTML;
      if (content) {
        const parsed = JSON.parse(content.trim());
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch (e) {
      console.error('Error parsing CBD surcharge settings:', e);
    }
  }
  return [];
}

/**
 * Find first enabled CBD surcharge config whose postal_codes list contains the given postal code (case-sensitive, trimmed).
 * @param {string} postalCode - Postal code to match
 * @param {Array} cbdSettings - Array of { enable, postal_codes, product }
 * @returns {Object|null} Matching config or null
 */
function findMatchingCbdSurcharge(postalCode, cbdSettings) {
  if (!postalCode || !cbdSettings || cbdSettings.length === 0) {
    return null;
  }
  const trimmed = String(postalCode).trim();
  if (!trimmed) {
    return null;
  }
  for (const config of cbdSettings) {
    if (!config.enable || !config.postal_codes) {
      continue;
    }
    const codes = config.postal_codes.split(',').map(c => c.trim()).filter(Boolean);
    if (codes.includes(trimmed)) {
      return config;
    }
  }
  return null;
}

/**
 * Check if cart items have the specified tag
 * @param {Array} cartItems - Cart items array
 * @param {string} tag - Tag to check for
 * @returns {boolean}
 */
async function cartHasTag(cartItems, tag) {
  if (!cartItems || !Array.isArray(cartItems)) {
    return false;
  }
  
  // Check if any item has the tag
  for (const item of cartItems) {
    if (item.properties && item.properties._Is_Addon === 'true') {
      continue; // Skip addons
    }
    
    // First check if tags are already in the cart item
    if (item.product && item.product.tags && Array.isArray(item.product.tags)) {
      if (item.product.tags.includes(tag)) {
        return true;
      }
    } else if (item.product && item.product.handle) {
      // If tags are not available, fetch product data
      try {
        const response = await fetch(`/products/${item.product.handle}.js`);
        if (response.ok) {
          const product = await response.json();
          if (product.tags && Array.isArray(product.tags) && product.tags.includes(tag)) {
            return true;
          }
        }
      } catch (error) {
        console.error('Error fetching product for tag check:', error);
      }
    }
  }
  
  return false;
}

function getCartDeliveryDate(cart) {
  if (!cart || !cart.attributes) {
    return null;
  }
  
  return cart.attributes['Delivery-Date'] || null;
}

/**
 * Check if a postal code matches a surcharge postal_codes setting via partial (prefix) match.
 * Empty/blank postal_codes means the surcharge applies to all postal codes.
 * @param {string} postalCode - Customer postal code
 * @param {string} postalCodesSetting - Comma-separated prefixes from theme settings
 * @returns {boolean}
 */
function postalCodeMatchesSurcharge(postalCode, postalCodesSetting) {
  if (!postalCodesSetting || !String(postalCodesSetting).trim()) {
    return true;
  }
  if (!postalCode || !String(postalCode).trim()) {
    return false;
  }
  const trimmed = String(postalCode).trim();
  const codes = String(postalCodesSetting).split(',').map(c => c.trim()).filter(Boolean);
  return codes.some(code => trimmed.startsWith(code));
}

function findMatchingSurcharge(deliveryDate, surchargeSettings, postalCode) {
  if (!deliveryDate || !surchargeSettings || surchargeSettings.length === 0) {
    return null;
  }
  
  const parsedDates = parseDeliveryDate(deliveryDate);
  if (parsedDates.length === 0) {
    return null;
  }
  
  // Check each surcharge configuration
  for (const config of surchargeSettings) {
    if (!config.enable || !config.start_date || !config.end_date || !config.product) {
      continue;
    }
    
    // Check if any date in the parsed dates falls within the surcharge date range
    const isInRange = hasDateInRange(parsedDates, config.start_date, config.end_date);
    if (!isInRange) {
      continue;
    }

    if (!postalCodeMatchesSurcharge(postalCode, config.postal_codes)) {
      continue;
    }

    return config;
  }
  
  return null;
}

async function getVariantIdFromHandle(productHandle) {
  if (!productHandle) {
    return null;
  }
  
  // If it's already a numeric ID, return it
  if (/^\d+$/.test(productHandle)) {
    return productHandle;
  }
  
  // Otherwise, fetch product by handle to get variant ID
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error(`Failed to fetch product: ${response.status}`);
    }
    const product = await response.json();
    
    // Get first available variant
    if (product.variants && product.variants.length > 0) {
      return product.variants[0].id.toString();
    }
  } catch (error) {
    console.error('Error fetching product variant:', error);
  }
  
  return null;
}

async function addSurchargeToCart(surchargeProduct) {
  // Get variant ID from product handle if needed
  const variantId = await getVariantIdFromHandle(surchargeProduct);
  if (!variantId) {
    throw new Error('Could not determine variant ID for surcharge product');
  }
  
  const items = [{
    id: variantId,
    quantity: 1,
    properties: {
      '_Is_Addon': 'true'
    }
  }];
  
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json();
    });
}

async function addSurchargeAsNestedLine(surchargeProduct, parentLineKey) {
  // Get variant ID from product handle if needed
  const variantId = await getVariantIdFromHandle(surchargeProduct);
  if (!variantId) {
    throw new Error('Could not determine variant ID for surcharge product');
  }
  
      // For nested cart lines when parent is already in cart, we use parent_line_key
      // Note: This may require Cart Transform function or custom handling depending on Shopify version
      const items = [{
        id: variantId,
        quantity: 1,
        parent_line_key: parentLineKey,
        properties: {
          '_Is_Addon': 'true'
        }
      }];
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json();
    });
}

async function processNonMultishipSurcharge() {
  try {
    // Fetch current cart
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart');
    }
    const cart = await cartResponse.json();
    
    // --- Delivery surcharge (date + tags) ---
    const surchargeSettings = getSurchargeSettings();
    if (surchargeSettings && surchargeSettings.length > 0) {
      const cartItems = document.querySelectorAll('.cart-item[data-key]:not(.jsc-cart-item-addon)');
      const candidateConfigs = [];
      const foundSetNumbers = new Set();
      
      for (const cartItem of cartItems) {
        for (let setNum = 1; setNum <= 3; setNum++) {
          if (cartItem.hasAttribute(`data-surcharge-set-${setNum}`)) {
            foundSetNumbers.add(setNum);
          }
        }
      }
      
      for (const setNum of foundSetNumbers) {
        const configIndex = setNum - 1;
        if (configIndex < surchargeSettings.length && surchargeSettings[configIndex] && surchargeSettings[configIndex].enable) {
          candidateConfigs.push(surchargeSettings[configIndex]);
        }
      }
      
      if (candidateConfigs.length > 0) {
        const deliveryDate = getCartDeliveryDate(cart);
        if (!deliveryDate) {
          alert('There was an error processing the delivery surcharge. Please try again later.');
          return false;
        }
        const zapietInput = document.querySelector('#deliveryGeoSearchField');
        const postalCode = zapietInput ? (zapietInput.value || '').trim() : '';
        const matchingSurcharge = findMatchingSurcharge(deliveryDate, candidateConfigs, postalCode);
        if (matchingSurcharge && matchingSurcharge.product) {
          try {
            await addSurchargeToCart(matchingSurcharge.product);
          } catch (error) {
            console.error('Error adding surcharge product:', error);
            alert('There was an error processing the delivery surcharge. Please try again later.');
            return false;
          }
        }
      }
    }
    
    // --- CBD/Sentosa/Tuas surcharge (Zapiet postal #deliveryGeoSearchField) ---
    const cbdSurchargeSettings = getCbdSurchargeSettings();
    if (cbdSurchargeSettings && cbdSurchargeSettings.length > 0) {
      const zapietInput = document.querySelector('#deliveryGeoSearchField');
      const postalCode = zapietInput ? (zapietInput.value || '').trim() : '';
      const matchingCbd = findMatchingCbdSurcharge(postalCode, cbdSurchargeSettings);
      if (matchingCbd && matchingCbd.product) {
        try {
          await addSurchargeToCart(matchingCbd.product);
        } catch (error) {
          console.error('Error adding CBD surcharge product:', error);
          alert('There was an error processing the CBD surcharge. Please try again later.');
          return false;
        }
      }
    }
    
    return true;
  } catch (error) {
    console.error('Error processing non-multiship surcharge:', error);
    alert('There was an error processing the delivery surcharge. Please try again later.');
    return false;
  }
}

/**
 * Process multishipping shipping and surcharge products together
 * - Fetches cart via API first to get latest item keys
 * - Gets data from rendered cart items (data-surcharge-set-1, data-index)
 * - Matches DOM items to API cart items using data-index
 * - Gets Cart attribute ['Delivery-Date']
 * - Builds array with shipping products (one per unique address) and surcharge products (one per matching item)
 * - Adds all items in one go via /cart/add.js
 * @returns {Promise<boolean>} Success status
 */
async function processMultishipShippingAndSurcharge() {
  try {
    // Step 1: Fetch cart via API first to get latest item keys
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart');
    }
    const cart = await cartResponse.json();
    
    // Step 2: Get delivery date from cart attributes
    const deliveryDate = getCartDeliveryDate(cart);
    if (!deliveryDate) {
      alert('There was an error processing the delivery surcharge. Please try again later.');
      return false;
    }
    
    // Step 3: Create a map from data-index (1-based) to API cart item
    // Use ALL cart items (including addons) to preserve original indices
    // API cart items array index is 0-based, DOM has data-index (1-based)
    const indexToCartItem = new Map();
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      // Array index i is 0-based, data-index is 1-based
      const dataIndex = i + 1;
      indexToCartItem.set(dataIndex.toString(), item);
    }
    
    // Step 4: Filter API cart items to get only main items (exclude addons and GWP) for later use
    const mainCartItems = cart.items.filter(item => {
      return !(item.properties && (item.properties._Is_Addon === 'true' || item.properties._is_gwp === 'true'));
    });
    
    // Step 5: Get surcharge settings
    const surchargeSettings = getSurchargeSettings();
    
    // Step 6: Get cart items from DOM with data-index and surcharge attributes
    const cartItemRows = document.querySelectorAll('.cart cart-items .cart-item[data-index]:not(.jsc-cart-item-addon):not([data-is-gwp="true"])');
    
    if (cartItemRows.length === 0) {
      console.error('No main cart items found in DOM');
      return false;
    }
    
    // Step 7: Group items by unique address and collect item data with latest keys from API
    const addressGroups = new Map(); // Map<addressString, Array<{key, element, dataIndex}>>
    const itemsByDataIndex = new Map(); // Map<dataIndex, {element, address, apiKey}>
    
    for (const cartItemRow of cartItemRows) {
      const dataIndex = cartItemRow.dataset.index;
      if (!dataIndex) {
        continue;
      }
      
      // Get corresponding API cart item to get latest key
      const apiCartItem = indexToCartItem.get(dataIndex);
      if (!apiCartItem) {
        continue;
      }
      
      // Skip if this API item is an addon (shouldn't happen since DOM query excludes addons, but safety check)
      if (apiCartItem.properties && apiCartItem.properties._Is_Addon === 'true') {
        continue;
      }
      
      const latestKey = apiCartItem.key;
      
      // Get address from DOM - try multiple methods
      let addressValue = '';
      
      // Method 1: Try "Recipient Address" property (combined address)
      const addressProperty = cartItemRow.querySelector('[data-property="Recipient Address"]');
      if (addressProperty) {
        const ddElement = addressProperty.querySelector('dd');
        if (ddElement) {
          addressValue = ddElement.textContent?.trim() || '';
        }
      }
      
      // Method 2: If no combined address, try individual address1 property
      if (!addressValue) {
        const address1Property = cartItemRow.querySelector('[data-property="_address_address1"]');
        if (address1Property) {
          const ddElement = address1Property.querySelector('dd');
          if (ddElement) {
            addressValue = ddElement.textContent?.trim() || '';
          }
        }
      }
      
      // Method 3: Fallback to API cart item properties
      if (!addressValue && apiCartItem.properties) {
        // Try combined address first
        addressValue = apiCartItem.properties['Recipient Address'] || '';
        // If not found, try individual address1
        if (!addressValue) {
          addressValue = apiCartItem.properties['_address_address1'] || '';
        }
      }
      
      if (!addressValue) {
        continue;
      }
      
      // Group by address
      if (!addressGroups.has(addressValue)) {
        addressGroups.set(addressValue, []);
      }
      addressGroups.get(addressValue).push({ 
        key: latestKey, 
        element: cartItemRow,
        dataIndex: dataIndex
      });
      
      // Store item data with latest key from API
      itemsByDataIndex.set(dataIndex, { 
        element: cartItemRow, 
        address: addressValue,
        apiKey: latestKey
      });
    }
    
    if (addressGroups.size === 0) {
      console.error('No items with addresses found');
      return false;
    }
    
    // Step 8: Build array of items to add (shipping + surcharge)
    const itemsToAdd = [];
    const shippingItems = [];
    const shippingParents = new Set();
    const shippingProductVariantId = getMultishipShippingVariantId();
    if (!shippingProductVariantId) {
      throw new Error('Multiship shipping product is not set');
    }
    
    // Step 8a: One nested shipping line per recipient. Quantity must stay 1.
    // Identical properties make Shopify reuse one line key and stack quantity.
    for (const [, items] of addressGroups.entries()) {
      const parentKey = items[0].key;
      if (!parentKey || shippingParents.has(parentKey)) {
        continue;
      }
      shippingParents.add(parentKey);
      shippingItems.push({
        id: shippingProductVariantId,
        quantity: 1,
        parent_line_key: parentKey,
        properties: {
          '_Is_Addon': 'true',
          '_ship_for': parentKey
        }
      });
    }
    
    // Step 8b: Add surcharge products - check each item against surcharge settings
    if (surchargeSettings && surchargeSettings.length > 0) {
      // Parse delivery dates once
      const parsedDates = parseDeliveryDate(deliveryDate);
      
      if (parsedDates.length > 0) {
        // First pass: collect all surcharge items that need to be added
        const surchargeItemsToAdd = [];
        
        for (const [dataIndex, itemData] of itemsByDataIndex.entries()) {
          const cartItemRow = itemData.element;
          const latestKey = itemData.apiKey;
          
          // Check for data-surcharge-set-1, data-surcharge-set-2, data-surcharge-set-3
          const candidateConfigs = [];
          const foundSetNumbers = new Set();
          
          for (let setNum = 1; setNum <= 3; setNum++) {
            const hasSurchargeSet = cartItemRow.hasAttribute(`data-surcharge-set-${setNum}`);
            if (hasSurchargeSet) {
              foundSetNumbers.add(setNum);
            }
          }
          
          // If item has no surcharge data attributes, skip it
          if (foundSetNumbers.size === 0) {
            continue;
          }
          
          // Map set numbers to config indices and collect enabled configs
          for (const setNum of foundSetNumbers) {
            const configIndex = setNum - 1;
            if (configIndex < surchargeSettings.length && 
                surchargeSettings[configIndex] && 
                surchargeSettings[configIndex].enable) {
              candidateConfigs.push(surchargeSettings[configIndex]);
            }
          }
          
          // If no enabled configs found for this item, skip it
          if (candidateConfigs.length === 0) {
            continue;
          }
          
          // Check which of the candidate configs matches the delivery date and postal code
          const zipEl = cartItemRow.querySelector('[data-property="_address_zip"] dd');
          const postalFromDom = zipEl ? (zipEl.textContent || '').trim() : '';
          const apiCartItem = indexToCartItem.get(dataIndex);
          const postalFromApi = apiCartItem && apiCartItem.properties ? (apiCartItem.properties._address_zip || '').trim() : '';
          const postalCode = postalFromDom || postalFromApi;
          const matchingSurcharge = findMatchingSurcharge(deliveryDate, candidateConfigs, postalCode);
          
          if (matchingSurcharge && matchingSurcharge.product) {
            surchargeItemsToAdd.push({
              productHandle: matchingSurcharge.product,
              parentLineKey: latestKey // Use latest key from API
            });
          }
        }
        
        // Second pass: get variant IDs in parallel
        if (surchargeItemsToAdd.length > 0) {
          const surchargeItemsWithVariants = await Promise.all(
            surchargeItemsToAdd.map(async (surcharge) => {
              const variantId = await getVariantIdFromHandle(surcharge.productHandle);
              if (!variantId) {
                throw new Error(`Could not determine variant ID for surcharge product: ${surcharge.productHandle}`);
              }
              return {
                id: variantId,
                quantity: 1,
                parent_line_key: surcharge.parentLineKey, // Latest key from API
                properties: {
                  '_Is_Addon': 'true',
                  '_surcharge_for': surcharge.parentLineKey
                }
              };
            })
          );
          
          // Add all surcharge items to the main array
          itemsToAdd.push(...surchargeItemsWithVariants);
        }
      }
    }
    
    // Step 8c: Add CBD surcharge products - one per address whose postal matches a CBD set
    const cbdSurchargeSettings = getCbdSurchargeSettings();
    if (cbdSurchargeSettings && cbdSurchargeSettings.length > 0) {
      const cbdItemsToAdd = [];
      for (const [dataIndex, itemData] of itemsByDataIndex.entries()) {
        const cartItemRow = itemData.element;
        const latestKey = itemData.apiKey;
        let hasCbdSet = false;
        for (let setNum = 1; setNum <= 3; setNum++) {
          if (cartItemRow.hasAttribute(`data-cbd-surcharge-set-${setNum}`)) {
            hasCbdSet = true;
            break;
          }
        }
        if (!hasCbdSet) {
          continue;
        }
        const zipEl = cartItemRow.querySelector('[data-property="_address_zip"] dd');
        const postalCode = zipEl ? (zipEl.textContent || '').trim() : '';
        const apiCartItem = indexToCartItem.get(dataIndex);
        const postalFromApi = apiCartItem && apiCartItem.properties ? (apiCartItem.properties._address_zip || '').trim() : '';
        const postal = postalCode || postalFromApi;
        const matchingCbd = findMatchingCbdSurcharge(postal, cbdSurchargeSettings);
        if (matchingCbd && matchingCbd.product) {
          cbdItemsToAdd.push({
            productHandle: matchingCbd.product,
            parentLineKey: latestKey
          });
        }
      }
      if (cbdItemsToAdd.length > 0) {
        const cbdItemsWithVariants = await Promise.all(
          cbdItemsToAdd.map(async (cbd) => {
            const variantId = await getVariantIdFromHandle(cbd.productHandle);
            if (!variantId) {
              throw new Error(`Could not determine variant ID for CBD surcharge product: ${cbd.productHandle}`);
            }
            return {
              id: variantId,
              quantity: 1,
              parent_line_key: cbd.parentLineKey,
              properties: {
                '_Is_Addon': 'true',
                '_cbd_for': cbd.parentLineKey
              }
            };
          })
        );
        itemsToAdd.push(...cbdItemsWithVariants);
      }
    }
    
    // Step 9: Replace any shipping already in the cart, then add one qty-1 line per recipient.
    // A single /cart/add.js batch of the same shipping variant increments quantity.
    const existingShippingLines = [];
    cart.items.forEach((item, index) => {
      if (Number(item.variant_id) === Number(shippingProductVariantId)) {
        existingShippingLines.push(index + 1);
      }
    });
    if (existingShippingLines.length > 0) {
      await removeCartLinesByLineNumber(existingShippingLines);
    }

    for (const shippingItem of shippingItems) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [shippingItem] })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await response.json();
    }

    if (itemsToAdd.length > 0) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      await response.json();
    }

    await normalizeNestedShippingQuantity(shippingProductVariantId, shippingItems.length);
    
    return true;
  } catch (error) {
    console.error('Error processing multiship shipping and surcharge:', error);
    alert('There was an error processing the delivery surcharge. Please try again later.');
    return false;
  }
}

async function processMultishipSurcharge() {
  try {
    const cartResponse = await fetch('/cart.js');

    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart');
    }

    const cart = await cartResponse.json();
    
    const surchargeSettings = getSurchargeSettings();
    if (!surchargeSettings || surchargeSettings.length === 0) {
      return true;
    }
    
    const mainItemKeys = [];
    const mainItems = [];
    
    for (const item of cart.items) {
      if (item.properties && item.properties._Is_Addon === 'true') {
        continue;
      }
      
      mainItemKeys.push(item.key);
      mainItems.push(item);
    }
    
    if (mainItems.length === 0) {
      return true;
    }
    
    const deliveryDate = getCartDeliveryDate(cart);
    if (!deliveryDate) {
      alert('There was an error processing the delivery surcharge. Please try again later.');
      return false;
    }
    
    // Parse delivery dates
    const parsedDates = parseDeliveryDate(deliveryDate);
    if (parsedDates.length === 0) {
      return true;
    }
    
    const surchargeItems = [];
    
    // Get cart items from DOM to check data attributes
    const cartItemRows = document.querySelectorAll('.cart-item[data-key]:not(.jsc-cart-item-addon)');
    
    for (const mainItem of mainItems) {
      // Find corresponding DOM element for this cart item
      const cartItemRow = Array.from(cartItemRows).find(row => row.dataset.key === mainItem.key);
      
      if (!cartItemRow) {
        continue;
      }
      
      // Step 1: Collect all enabled surcharge configs that have matching data attributes for this item
      const candidateConfigs = [];
      const foundSetNumbers = new Set();
      
      // Check for data-surcharge-set-1, data-surcharge-set-2, data-surcharge-set-3
      for (let setNum = 1; setNum <= 3; setNum++) {
        const hasSurchargeSet = cartItemRow.hasAttribute(`data-surcharge-set-${setNum}`);
        if (hasSurchargeSet) {
          foundSetNumbers.add(setNum);
        }
      }
      
      // If item has no surcharge data attributes, skip it
      if (foundSetNumbers.size === 0) {
        continue;
      }
      
      // Map set numbers to config indices and collect enabled configs
      for (const setNum of foundSetNumbers) {
        const configIndex = setNum - 1;
        if (configIndex < surchargeSettings.length && surchargeSettings[configIndex] && surchargeSettings[configIndex].enable) {
          candidateConfigs.push(surchargeSettings[configIndex]);
        }
      }
      
      // If no enabled configs found for this item, skip it
      if (candidateConfigs.length === 0) {
        continue;
      }
      
      // Step 2: Check which of the candidate configs matches the delivery date and postal code
      const postalCode = (mainItem.properties && mainItem.properties._address_zip)
        ? String(mainItem.properties._address_zip).trim()
        : '';
      const matchingSurcharge = findMatchingSurcharge(deliveryDate, candidateConfigs, postalCode);
      
      if (matchingSurcharge && matchingSurcharge.product) {
        surchargeItems.push({
          productId: matchingSurcharge.product,
          parentLineKey: mainItem.key
        });
      }
    }
    
    if (surchargeItems.length > 0) {
      const itemsWithVariants = await Promise.all(
        surchargeItems.map(async (surcharge) => {
          const variantId = await getVariantIdFromHandle(surcharge.productId);
          if (!variantId) {
            throw new Error(`Could not determine variant ID for surcharge product: ${surcharge.productId}`);
          }
          return {
            id: variantId,
            quantity: 1,
            parent_line_key: surcharge.parentLineKey,
            properties: {
              '_Is_Addon': 'true'
            }
          };
        })
      );
      
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsWithVariants })
        }).then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        });
        
        return true;
      } catch (error) {
        console.error('Error adding surcharge products:', error);
        alert('There was an error processing the delivery surcharge. Please try again later.');
        return false;
      }
    }
    
    return true; // No surcharges needed, proceed normally
  } catch (error) {
    console.error('Error processing multiship surcharge:', error);
    alert('There was an error processing the delivery surcharge. Please try again later.');
    return false;
  }
}

//end: Delivery Surcharge Logic
//end: Multishipping checkout

// start: custom Zapiet validator
validateZipCode = (e) => {        
  const zipcode = document.getElementById('zipcode').value;
 
  if (
    typeof window.Zapiet === 'undefined' ||
    typeof window.ZapietCachedSettings === 'undefined' ||
    typeof window.ZapietDeliveryValidator === 'undefined' ||
    typeof window.ZapietCachedSettings.cached_config === 'undefined' || 
    typeof window.ZapietCachedSettings.cached_config.delivery_validator === 'undefined'
  ) {
    console.warn('Zapiet - Custom delivery validator error. Please ensure you have Store Pickup + Delivery correctly installed. Contact support@zapiet.com for assistance.');
    return false;
  }

  ZapietDeliveryValidator.checkEligibility(zipcode, function(response) {
     // Eligible callback
     ZapietDeliveryValidator.eligibleForDelivery(response);
  }, function() {
     // Not eligible callback
     ZapietDeliveryValidator.notEligibleForDelivery();
  }, function() {
     // Error callback
     ZapietDeliveryValidator.error();
  });
       
  return false;
}
// end: custom Zapiet validator

// start: hide WhatsApp widget on weekends
const hideWhatsAppWidgetOnWeekends = () => {
  const day = new Date().getDay();
  if (day !== 0 && day !== 6) return; // 0 = Sun, 6 = Sat

  const hide = () => {
    const el = document.getElementById('cx_whatsapp_init');
    if (!el) return false;
    el.style.display = 'none';
    return true;
  };

  if (hide()) return;

  const observer = new MutationObserver(() => {
    if (hide()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
// end: hide WhatsApp widget on weekends


// start: cart page cutoff time
const parseCartPageCutoffRefreshTimes = (timesString) => {
  if (!timesString || typeof timesString !== 'string') {
    return [];
  }

  const cutoffs = [];

  timesString.split(',').forEach((part) => {
    const trimmed = part.trim();
    if (!trimmed) {
      return;
    }

    const match = trimmed.match(/^(\d{1,2}):(\d{2})\s*(am|pm)?$/i);
    if (!match) {
      console.warn(`Invalid cart cutoff refresh time: "${trimmed}"`);
      return;
    }

    let hour = parseInt(match[1], 10);
    const minute = parseInt(match[2], 10);
    const meridiem = match[3] ? match[3].toLowerCase() : null;

    if (meridiem === 'pm' && hour < 12) {
      hour += 12;
    }
    if (meridiem === 'am' && hour === 12) {
      hour = 0;
    }

    if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
      console.warn(`Invalid cart cutoff refresh time: "${trimmed}"`);
      return;
    }

    cutoffs.push({ hour, minute });
  });

  return cutoffs;
}

const scheduleCartPageCutoffRefresh = () => {
  if (!window.location.pathname.includes('/cart')) {
    return;
  }

  const timesString = FoxTheme?.settings?.cartPageCutoffRefreshTimes;
  const cutoffTimes = parseCartPageCutoffRefreshTimes(timesString);

  if (cutoffTimes.length === 0) {
    return;
  }

  const now = new Date();

  cutoffTimes.forEach(({ hour, minute }) => {
    const target = new Date(now);
    target.setHours(hour, minute, 0, 0);

    if (target <= now) {
      target.setDate(target.getDate() + 1);
    }

    setTimeout(() => {
      window.location.reload();
    }, target - now);
  });
};
// end: cart page cutoff time

// start: GWP
const gwpSetup = () => {
  let gwpSyncing = false;
  let gwpSyncPending = false;
  let gwpPublishing = false;
  let gwpInitialized = false;

  const GWP_DISMISS_KEY = 'jsc_gwp_dismissed_until';
  const GWP_DISMISS_MS = 7 * 24 * 60 * 60 * 1000;

  const getGwpConfig = () => FoxTheme?.settings?.gwp || {};

  const INTERNATIONAL_DELIVERY_TAG = 'international delivery';
  const intlTagCache = new Map();

  const isGwpLine = (item) => item?.properties?._is_gwp === 'true';

  const isAddonLine = (item) => item?.properties?._Is_Addon === 'true';

  const tagsIncludeInternationalDelivery = (tags) => {
    if (!Array.isArray(tags)) return false;
    return tags.some((tag) => String(tag).toLowerCase().includes(INTERNATIONAL_DELIVERY_TAG));
  };

  // Prefer DOM intl status when present; otherwise fetch product tags (cart.js has no tags).
  const cartHasInternationalDelivery = async (cart) => {
    const domIntlByProductId = new Map();
    document.querySelectorAll('.cart-item[data-product-id][data-intl-status]').forEach((el) => {
      if (el.dataset.isGwp === 'true') return;
      const productId = Number(el.dataset.productId);
      if (!productId || domIntlByProductId.has(productId)) return;
      const status = String(el.dataset.intlStatus || '').toLowerCase();
      domIntlByProductId.set(productId, status.includes(INTERNATIONAL_DELIVERY_TAG));
    });

    for (const item of cart.items || []) {
      if (isAddonLine(item) || isGwpLine(item)) continue;

      if (item.product?.tags && tagsIncludeInternationalDelivery(item.product.tags)) {
        return true;
      }

      const productId = Number(item.product_id);
      if (productId && domIntlByProductId.has(productId)) {
        if (domIntlByProductId.get(productId)) return true;
        continue;
      }

      if (productId && intlTagCache.has(productId)) {
        if (intlTagCache.get(productId)) return true;
        continue;
      }

      const handle = item.handle || item.product?.handle;
      if (!handle) continue;

      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) continue;
        const product = await response.json();
        const hasIntl = tagsIncludeInternationalDelivery(product.tags);
        if (productId) intlTagCache.set(productId, hasIntl);
        if (hasIntl) return true;
      } catch (error) {
        console.error('GWP international delivery tag check failed:', error);
      }
    }

    return false;
  };

  const isGwpDismissed = () => {
    try {
      const until = Number(localStorage.getItem(GWP_DISMISS_KEY));
      if (!until) return false;
      if (Date.now() > until) {
        localStorage.removeItem(GWP_DISMISS_KEY);
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const setGwpDismissed = () => {
    try {
      localStorage.setItem(GWP_DISMISS_KEY, String(Date.now() + GWP_DISMISS_MS));
    } catch (error) {
      // Ignore storage failures (private mode, quota, etc.)
    }
  };

  const clearGwpDismissed = () => {
    try {
      localStorage.removeItem(GWP_DISMISS_KEY);
    } catch (error) {
      // Ignore storage failures
    }
  };

  const getSectionsToUpdate = () => {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  };

  const buildCollectionMapFromDom = () => {
    const map = new Map();
    document.querySelectorAll('.cart-item[data-product-id]').forEach((el) => {
      const productId = Number(el.dataset.productId);
      if (!productId || map.has(productId)) return;
      const ids = (el.dataset.collectionIds || '')
        .split(',')
        .map((id) => Number(id.trim()))
        .filter(Boolean);
      map.set(productId, ids);
    });
    return map;
  };

  const itemInCollections = (item, collectionIds, collectionMap) => {
    if (!collectionIds.length) return true;
    const productId = item.product_id;
    const itemCollectionIds = collectionMap.get(productId) || [];
    return collectionIds.some((id) => itemCollectionIds.includes(id));
  };

  const getQualifyingSubtotal = (cart, config, collectionMap) => {
    const collectionIds = Array.isArray(config.collectionIds) ? config.collectionIds.map(Number).filter(Boolean) : [];
    const gwpProductId = Number(config.productId) || null;

    return (cart.items || []).reduce((sum, item) => {
      if (isGwpLine(item)) return sum;
      if (gwpProductId && item.product_id === gwpProductId) return sum;
      if (!itemInCollections(item, collectionIds, collectionMap)) return sum;
      return sum + (item.final_line_price || 0);
    }, 0);
  };

  const getThresholdCents = (config) => {
    const minimum = Number(config.minimumSubtotal) || 0;
    const rate = Number(window.Shopify?.currency?.rate || 1);
    return minimum * 100 * rate;
  };

  const isEligible = (cart, config, collectionMap) => {
    if (!config.enabled || !config.variantId) return false;
    const threshold = getThresholdCents(config);
    if (threshold <= 0) return false;
    return getQualifyingSubtotal(cart, config, collectionMap) >= threshold;
  };

  const findGwpLines = (cart) => (cart.items || []).filter(isGwpLine);

  const getGiftWrapVariantId = () => {
    const el = document.querySelector('gift-wrapping[data-gift-wrap-id]');
    const id = Number(el?.dataset?.giftWrapId);
    return id || null;
  };

  const isParentCandidate = (item, config) => {
    if (!item) return false;
    if (isAddonLine(item) || isGwpLine(item)) return false;
    const gwpProductId = Number(config.productId) || null;
    if (gwpProductId && item.product_id === gwpProductId) return false;
    const giftWrapId = getGiftWrapVariantId();
    if (giftWrapId && item.id === giftWrapId) return false;
    return true;
  };

  // Highest unit price wins; tie-break on line total, then cart position.
  const findHighestPricedParent = (cart, config) => {
    let best = null;
    (cart.items || []).forEach((item, index) => {
      if (!isParentCandidate(item, config)) return;
      if (!best) {
        best = { item, index };
        return;
      }
      const price = item.final_price || 0;
      const bestPrice = best.item.final_price || 0;
      if (price > bestPrice) {
        best = { item, index };
        return;
      }
      if (price === bestPrice) {
        const lineTotal = item.final_line_price || 0;
        const bestLineTotal = best.item.final_line_price || 0;
        if (lineTotal > bestLineTotal || (lineTotal === bestLineTotal && index < best.index)) {
          best = { item, index };
        }
      }
    });
    return best?.item || null;
  };

  const countMainLinesWithBinding = (cart, bindingId) =>
    (cart?.items || []).filter(
      (item) => !isAddonLine(item) && !isGwpLine(item) && item.properties?._Binding_ID === bindingId
    ).length;

  // GWP must sit on a single qty-1 host. Shared Binding_ID across parents re-renders the gift twice.
  const isGwpAttachedToParent = (gwpLine, parent, cart) => {
    if (!gwpLine || !parent) return false;
    if (parent.quantity !== 1) return false;
    if (!isAddonLine(gwpLine)) return false;
    const gwpBinding = gwpLine.properties?._Binding_ID;
    const parentBinding = parent.properties?._Binding_ID;
    if (!gwpBinding || !parentBinding || gwpBinding !== parentBinding) return false;
    if (gwpLine.quantity !== 1) return false;
    return countMainLinesWithBinding(cart, parentBinding) === 1;
  };

  const publishCartUpdate = (parsedState) => {
    if (FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
      gwpPublishing = true;
      try {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
      } finally {
        gwpPublishing = false;
      }
    }
  };

  const fetchCart = async () => {
    const response = await fetch(`${FoxTheme.routes.cart_url}.js`, {
      ...FoxTheme.utils.fetchConfig(),
    });
    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  };

  const fetchCartWithSections = async (sections) => {
    const cartJson = await fetchCart();
    if (sections?.length) {
      const sectionResponse = await fetch(`${FoxTheme.routes.cart_update_url}`, {
        ...FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({ sections }),
      });
      const sectionState = await sectionResponse.json();
      cartJson.sections = sectionState.sections;
    }
    return cartJson;
  };

  const changeLine = async (key, quantity, properties) => {
    const response = await fetch(`${FoxTheme.routes.cart_change_url}.js`, {
      ...FoxTheme.utils.fetchConfig(),
      body: JSON.stringify({
        id: key,
        quantity,
        properties,
      }),
    });
    const parsedState = await response.json();
    if (parsedState.status) {
      throw new Error(parsedState.description || parsedState.message || 'Failed to update cart line');
    }
    return parsedState;
  };

  // Strip _Binding_ID from main lines when no addons remain on that binding.
  const clearOrphanedBindingsFromMains = async (cart, bindingIds) => {
    const uniqueIds = [
      ...new Set(
        (bindingIds || [])
          .map((id) => String(id || '').trim())
          .filter(Boolean)
      ),
    ];
    let nextCart = cart;

    for (const bindingId of uniqueIds) {
      const hasRemainingAddon = (nextCart.items || []).some(
        (item) => isAddonLine(item) && String(item.properties?._Binding_ID || '') === bindingId
      );
      if (hasRemainingAddon) continue;

      const mains = (nextCart.items || []).filter(
        (item) =>
          !isAddonLine(item) &&
          !isGwpLine(item) &&
          String(item.properties?._Binding_ID || '') === bindingId
      );

      for (const main of mains) {
        const cleaned = { ...(main.properties || {}) };
        if (!Object.prototype.hasOwnProperty.call(cleaned, '_Binding_ID')) continue;
        delete cleaned._Binding_ID;
        nextCart = await changeLine(main.key, main.quantity, cleaned);
      }
    }

    return nextCart;
  };

  const getOrphanedMainBindingIds = (cart) => {
    const ids = [];
    (cart.items || []).forEach((item) => {
      if (isAddonLine(item) || isGwpLine(item)) return;
      const bindingId = String(item.properties?._Binding_ID || '').trim();
      if (!bindingId || ids.includes(bindingId)) return;
      const hasAddon = (cart.items || []).some(
        (line) => isAddonLine(line) && String(line.properties?._Binding_ID || '') === bindingId
      );
      if (!hasAddon) ids.push(bindingId);
    });
    return ids;
  };

  const removeGwpLines = async (gwpLines, { withSections = false } = {}) => {
    if (!gwpLines.length) return null;
    const bindingIds = gwpLines
      .map((line) => line.properties?._Binding_ID)
      .filter((id) => id && String(id).trim() !== '');

    const updates = {};
    gwpLines.forEach((line) => {
      updates[line.key] = 0;
    });
    // Remove GWP first; refresh sections after parent binding cleanup so UI is not stale.
    const response = await fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      body: JSON.stringify({ updates }),
    });
    let cart = await response.json();
    cart = await clearOrphanedBindingsFromMains(cart, bindingIds);

    if (withSections) {
      cart = await fetchCartWithSections(getSectionsToUpdate());
    }
    return cart;
  };

  const findParentByBinding = (cart, variantId, bindingId) => {
    const matches = (cart.items || []).filter(
      (item) =>
        !isAddonLine(item) &&
        !isGwpLine(item) &&
        item.variant_id === variantId &&
        item.properties?._Binding_ID === bindingId
    );
    return matches.find((item) => item.quantity === 1) || matches[0] || null;
  };

  // Host GWP on exactly one qty-1 line so Binding_ID never renders the gift under multiple rows.
  const prepareGwpParent = async (parent, cart) => {
    const existingBinding = parent.properties?._Binding_ID;
    const bindingId =
      existingBinding && String(existingBinding).trim() !== ''
        ? String(existingBinding)
        : generateRandomString();
    const remainder = Math.max(0, (Number(parent.quantity) || 1) - 1);
    const hostProperties = { ...(parent.properties || {}), _Binding_ID: bindingId };
    let nextCart = cart;
    let host = parent;
    let changed = false;

    if (host.quantity !== 1 || host.properties?._Binding_ID !== bindingId) {
      nextCart = await changeLine(host.key, 1, hostProperties);
      host = findParentByBinding(nextCart, parent.variant_id, bindingId);
      if (!host) throw new Error('GWP parent missing after qty split');
      changed = true;
    }

    if (remainder > 0) {
      const remainderProperties = { ...hostProperties };
      delete remainderProperties._Binding_ID;

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(parent.variant_id),
              quantity: remainder,
              properties: remainderProperties,
            },
          ],
        }),
      });
      const addState = await addResponse.json();
      if (addState.status) {
        throw new Error(addState.description || addState.message || 'Failed to split GWP parent quantity');
      }

      nextCart = await fetchCart();
      host = findParentByBinding(nextCart, parent.variant_id, bindingId);
      if (!host) throw new Error('GWP parent missing after remainder add');
      changed = true;
    }

    const duplicateHosts = (nextCart.items || []).filter(
      (item) =>
        !isAddonLine(item) &&
        !isGwpLine(item) &&
        item.key !== host.key &&
        item.properties?._Binding_ID === bindingId
    );

    for (const dup of duplicateHosts) {
      const cleaned = { ...(dup.properties || {}) };
      delete cleaned._Binding_ID;
      nextCart = await changeLine(dup.key, dup.quantity, cleaned);
      changed = true;
    }

    if (duplicateHosts.length) {
      host = findParentByBinding(nextCart, parent.variant_id, bindingId) || host;
    }

    return { parent: host, bindingId, cart: nextCart, changed };
  };

  const addGwpAsAddon = async (variantId, parent, bindingId, { withSections = true } = {}) => {
    const sections = withSections ? getSectionsToUpdate() : [];
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            parent_line_key: parent.key,
            properties: {
              _is_gwp: 'true',
              _Is_Addon: 'true',
              _Binding_ID: bindingId,
            },
          },
        ],
        sections,
      }),
    });
    const parsedState = await response.json();
    if (parsedState.status) {
      throw new Error(parsedState.description || parsedState.message || 'Failed to add GWP');
    }

    if (parsedState.sections) {
      const cartJson = await fetchCart();
      cartJson.sections = parsedState.sections;
      return cartJson;
    }

    return fetchCartWithSections(sections);
  };

  // Re-fetch before mutate so event cart snapshots cannot cause a second add.
  const syncGwp = async () => {
    if (gwpSyncing) {
      // Ignore feedback from our own publish; queue real concurrent cart changes.
      if (!gwpPublishing) gwpSyncPending = true;
      return;
    }

    const config = getGwpConfig();
    gwpSyncing = true;
    let finalCart = null;
    try {
      let cart = await fetchCart();
      const collectionMap = buildCollectionMapFromDom();
      let gwpLines = findGwpLines(cart);

      if (!cart.items?.length) {
        clearGwpDismissed();
        if (gwpLines.length > 0) {
          finalCart = await removeGwpLines(gwpLines, { withSections: true });
          publishCartUpdate(finalCart);
        }
        return;
      }

      const hasInternationalDelivery = await cartHasInternationalDelivery(cart);
      const eligible = !hasInternationalDelivery && isEligible(cart, config, collectionMap);
      const dismissed = Boolean(config.removable) && isGwpDismissed();

      if (!eligible) {
        if (gwpLines.length > 0) {
          finalCart = await removeGwpLines(gwpLines, { withSections: true });
          publishCartUpdate(finalCart);
        }
        return;
      }

      // Customer dismissed GWP — do not re-add for the dismiss window.
      if (dismissed) {
        if (gwpLines.length === 0) {
          // Manual GWP remove already deleted the gift line; still clear orphan parent bindings.
          const orphanBindingIds = getOrphanedMainBindingIds(cart);
          if (orphanBindingIds.length > 0) {
            await clearOrphanedBindingsFromMains(cart, orphanBindingIds);
            finalCart = await fetchCartWithSections(getSectionsToUpdate());
            publishCartUpdate(finalCart);
          }
          return;
        }

        let parent = findHighestPricedParent(cart, config);
        const correctlyAttached = parent && gwpLines.length === 1 && isGwpAttachedToParent(gwpLines[0], parent, cart);
        if (correctlyAttached) return;

        finalCart = await removeGwpLines(gwpLines, { withSections: true });
        publishCartUpdate(finalCart);
        return;
      }

      let parent = findHighestPricedParent(cart, config);
      if (!parent) {
        if (gwpLines.length > 0) {
          finalCart = await removeGwpLines(gwpLines, { withSections: true });
          publishCartUpdate(finalCart);
        }
        return;
      }

      const correctlyAttached = gwpLines.length === 1 && isGwpAttachedToParent(gwpLines[0], parent, cart);
      if (correctlyAttached) {
        return;
      }

      // Wrong parent, multi-qty host, missing addon props, standalone GWP, or duplicates → remove then re-attach.
      if (gwpLines.length > 0) {
        cart = (await removeGwpLines(gwpLines, { withSections: false })) || (await fetchCart());
        parent = findHighestPricedParent(cart, config);
        if (!parent) {
          finalCart = await fetchCartWithSections(getSectionsToUpdate());
          publishCartUpdate(finalCart);
          return;
        }
      }

      let prepared = await prepareGwpParent(parent, cart);
      parent = prepared.parent;
      let bindingId = prepared.bindingId;
      cart = prepared.cart;

      // Final guard after async gaps: another tab/event may have attached GWP already.
      // Keep the prepared qty-1 host — do not re-pick by line total (remainder can win).
      gwpLines = findGwpLines(cart);
      const preparedStillInCart = (cart.items || []).some((item) => item.key === parent.key);
      if (!preparedStillInCart) {
        parent = findHighestPricedParent(cart, config);
        if (!parent) {
          if (gwpLines.length > 0) {
            finalCart = await removeGwpLines(gwpLines, { withSections: true });
            publishCartUpdate(finalCart);
          }
          return;
        }
        prepared = await prepareGwpParent(parent, cart);
        parent = prepared.parent;
        bindingId = prepared.bindingId;
        cart = prepared.cart;
        gwpLines = findGwpLines(cart);
      }

      if (gwpLines.length === 1 && isGwpAttachedToParent(gwpLines[0], parent, cart)) {
        return;
      }

      if (gwpLines.length > 0) {
        cart = (await removeGwpLines(gwpLines, { withSections: false })) || (await fetchCart());
        parent = findHighestPricedParent(cart, config);
        if (!parent) {
          finalCart = await fetchCartWithSections(getSectionsToUpdate());
          publishCartUpdate(finalCart);
          return;
        }
        prepared = await prepareGwpParent(parent, cart);
        parent = prepared.parent;
        bindingId = prepared.bindingId;
        cart = prepared.cart;
      }

      // Re-check dismiss in case the customer removed GWP during async prep.
      if (config.removable && isGwpDismissed()) {
        return;
      }

      const latestBindingId = parent.properties?._Binding_ID || bindingId;
      if (!latestBindingId) {
        throw new Error('Missing Binding_ID before GWP add');
      }

      finalCart = await addGwpAsAddon(config.variantId, parent, latestBindingId, { withSections: true });
      publishCartUpdate(finalCart);
    } catch (error) {
      console.error('GWP sync error:', error);
    } finally {
      gwpSyncing = false;
      if (gwpSyncPending) {
        gwpSyncPending = false;
        syncGwp();
      }
    }
  };

  const initGwp = () => {
    if (gwpInitialized) return;
    gwpInitialized = true;

    document.addEventListener(
      'click',
      (event) => {
        const config = getGwpConfig();
        if (!config.removable) return;

        const removeBtn = event.target.closest('[data-gwp-remove="true"], [is="cart-remove-item"]');
        if (!removeBtn) return;

        const gwpRow = removeBtn.closest('[data-is-gwp="true"]');
        if (!gwpRow && removeBtn.getAttribute('data-gwp-remove') !== 'true') return;

        setGwpDismissed();
      },
      true
    );

    document.addEventListener('cart:updated', () => {
      syncGwp();
    });

    syncGwp();
  };

  initGwp();
}
// end: GWP
